/**
 * Adzuki
 * chatbot.js
 */

(function Chatbot($, Adzuki)
{
	"use strict";
	var mode                     = 'ask-maxx',
		isDarkMode               = false,
		askMaxxquestionAsked     = false,
		maxxIntelligenceAsked    = false,
		lastAnswerBad            = false,
		isExpanded               = false,
		originalHeight           = 0,
		badQuestionDetails       = {},
		askMaxxQuestion          = '',
		maxxIntelligenceQuestion = '',
		askMaxxErrorRetry        = 'Woof! That didn\'t work. Please enter another question and I\'ll try again',
		alertIcon                = '<i class="fa fa-exclamation-triangle"></i>',
		askMaxxErrorResponse     = 'Woof! Can you try asking that again?',
		streamPaintIntervalMs    = 60, // MAXX-170: min gap between formatted paints while streaming
		blueColor                = '#0080C5',
		greenColor               = '#39B54A',

		// kb_name → human-readable label and CSS class
		kbMeta = {
			vendor_partners: {
				label   : 'Partner Hub',
				cssClass: 'kb-partners',
			},
			destinations: {
				label   : 'Destinations',
				cssClass: 'kb-destinations',
			},
			cpgenie: {
				label   : 'CP Genie',
				cssClass: 'kb-cpgenie',
			},
			sailings: {
				label   : 'Sailings',
				cssClass: 'kb-sailings',
			},
			cpmaxx_howto: {
				label   : 'CP Maxx How To',
				cssClass: 'kb-cpmaxx-howto',
			},
		},

		// MAXX-156: specialists that answer for several knowledge bases, so their
		// name says nothing about the topic of the answer
		genericSpecialists = ['knowledge_agent'],

		intros                   = [
			'Woof! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m training to be the smartest dog bot ever! Ask me how to do something in CP Maxx, look up your own bookings and clients, or ask about sailings, destinations, Partner Hub suppliers and CP Genie. Let\'s embark on a tail-wagging adventure together! 🐶🚢',
			'Bark! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m on a mission to become the top dog in travel assistance! You can look up your own bookings and clients, ask how to do something in CP Maxx, or ask about Partner Hub suppliers, CP Genie, destinations and sailings. Ready to fetch some answers? 🐶✈️',
			'Howdy! I\'m Maxx, your Cruise Planners assistant! 🐾 I\'m working hard to be the best dog bot around! Ask me about CP Genie, sailings, Partner Hub suppliers and destinations, how to do something in CP Maxx, or your own bookings and clients. Let\'s sniff out the best information for you! 🐶🌍'
		],
		intelligenceIntros       = [
			'Hello! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Hi! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Hey! 👋 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
			'Woof! 🐶 This is Maxx Intelligence, your AI assistant. Go ahead and ask me anything.',
		];

	$(document).ready(function documentReady()
	{
		// Ensure tooltip plugin is initialized
		/*
		if ($.fn.tooltip) {
			$('[data-toggle="tooltip"]').tooltip({
				placement: function _tooltipPlacement(tooltip, element) {
					// Use 'left' placement for elements with class 'chatbot-topics-label'
					if ($(element).hasClass('chatbot-topics-label')) {
						return 'left';
					}
					// Use default placement for other tooltips
					return tooltip.options.placement;
				}
			});
		}
		*/

		// chatbot not used on Trip Summary, Maxx Media, or Web (for now since it triggers tooltip errors)
		if (Adzuki.app === 'TripSummary' || Adzuki.app === 'MediaHub' || Adzuki.app === 'Web') {
			return;
		}

		// if android, attempt to detect the keyboard and collapse the height of the window
		if ((/android/i).test(navigator.userAgent.toLowerCase())) {
			$(window).on('resize orientationchange', function _checkIfResized() {
				if (originalHeight === 0) {
					originalHeight = $('.chatbot-response').css('height');
					$('.chatbot-response').css('height', '15%');
				} else {
					$('.chatbot-response').css('height', originalHeight);
					originalHeight = 0;
				}
			});
		}

		// Add this check at the beginning of the documentReady function
		isDarkMode = $('body').hasClass('theme--dark');

		// Add global click event listener to remove tooltips
		$(document).on('click', function _clearAllTooltips() {
			if ($.fn.tooltip) { // Check if tooltip function is available
				$('[data-toggle="tooltip"]').tooltip('destroy');
			}
		});

		// when the logo is clicked, show the chatbot
		$('.chatbot-logo-container').on('click', function _chatBotClicked() {
			showChatBot();
		});

		// when the close button is clicked, hide the chatbot
		$('#chatbot-close').on('click', function _chatBotClose() {
			hideChatBot();
		});

		// copy the chatbot's response to the clipboard
		$('.chatbot-contents').on('click', '.chatbot-reply-copy', function _chatBotReplyCopy(e) {
			var chatBotReplyId = $(this).data('chatbot-reply-id'),
				$obj           = $(`#${chatBotReplyId}`);

			e.preventDefault();

			if ($obj.length === 0) {
				console.error('Element not found:', chatBotReplyId);
				Adzuki.StatusMessage('Error', 'Failed to find the response to copy');
				return;
			}

			copyResponseToClipboard($obj);
		});

		// send the response to the snippets system
		$('.chatbot-contents').on('click', '.chatbot-snippets', function _chatBotSnippets() {
			var chatBotReplyId = $(this).data('chatbot-reply-id'),
				$obj           = $(`#${chatBotReplyId}`);

			sendToSnippets($obj);
		});


		// send the history item to the snippets
		$('.chatbot-contents').on('click', '.history-snippets', function _historySnippets() {
			var historyId = $(this).data('history-id'),
				$obj           = $('#history-response-' + historyId);

			sendToSnippets($obj);
		});

		// Add click event for copy to clipboard
		$('.chatbot-contents').on('click', '.history-copy', function _copyHistoryToClipboard() {
			var historyId    = $(this).data('history-id'),
				$historyItem = $('#' + historyId);
			console.log($historyItem.find('.history-response p').html());
			copyResponseToClipboard($historyItem.find('.history-response p'));
		});

		// send the message to the chatbot
		$('#chatbot-submit').on('click', function _chatBotSubmit() {
			var chatbotMessage = $('#chatbot-entry').val().trim();

			$(this).tooltip('hide');

			$('.chatbot-specificity').html('');

			if (chatbotMessage === '') {
				askMaxxquestionAsked = false;

				if (lastAnswerBad === true) {
					maxxBubble(alertIcon + ' Please provide your feedback so I can learn what to do next!', '', false, true);
				} else {
					maxxBubble(alertIcon + ' I\'ll need you to ask a question first so that I can dig up the answer!', '', false, true);
				}

				scrollContents($('.chatbot-response'));
			} else {
				sendMessage(chatbotMessage);
			}
		});

		// restart / new conversation — now shows a sidebar with recent sessions (MAXX-118)
		$('#chatbot-restart').on('click', function _chatBotRestart() {
			if (mode === 'ask-maxx') {
				loadConversationSidebar();
			} else {
				restartMaxxIntelligence();
			}
		});

		// reloads the intro screens for each section depending on the mode
		$('#chatbot-home').on('click', function _chatBotHome() {
			if (mode === 'ask-maxx') {
				$('.chatbot-details-container').hide();
				$('.ask-maxx-card-intro').show();

				// IF they had started providing feedback, and bailed, then reset the variables
				$('#chatbot-entry').css('background-color', '#EFEFEF');
				$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
				lastAnswerBad = false;
			} else {
				$('.maxx-intelligence-details-container').hide();
				$('.maxx-intelligence-card-intro').show();
			}
		});

		// Modify the keypress event listeners
		$('#chatbot-entry').on('keydown', function _chatBotEntryKeypress(event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
				$('#chatbot-submit').click();
			}
		});

		$('#maxx-intelligence-entry').on('keydown', function _maxxIntelligenceEntryKeypress(event) {
			if (event.which === 13 && !event.shiftKey) {
				event.preventDefault();
				$('#maxx-intelligence-submit').click();
			}
		});

		// Remove any existing mouseover/mouseout handlers
		$('.chatbot-logo-container').off('mouseover mouseout');

		// Set the user photo in the after element
		setUserPhotoInAfter();

		// Set default active class for 'concise' specificity option
		$('.chatbot-specificity-option-button[data-specificity="concise"]').addClass('active');

		// Add click event handler for specificity option buttons
		$('.chatbot-specificity-option-button').on('click', function _chatBotSpecificityOptionButtonClicked() {
			var specificity = $(this).data('specificity');
			$('.chatbot-specificity-option-button').removeClass('active');
			$(this).addClass('active');

			setSpecificity(specificity);
		});

		// Expand/Contract chatbot
		$('.chatbot-expand').on('click', function _chatBotExpandClicked() {
			var $icon     = $(this).find('i'),
				$contents = $('.chatbot-contents');

			if ($icon.hasClass('fa-expand-alt')) {
				// Expand
				isExpanded = true;
				$icon.removeClass('fa-expand-alt').addClass('fa-compress-alt');
				$icon.attr('title', 'Contract');
				$icon.attr('data-original-title', 'Contract');
				$contents.css({
					position: 'fixed',
					zIndex  : 9999,
					top     : '10%',
					left    : '10%',
					width   : '80%',
					height  : '80%'
				});

				$('.chatbot-entry').css('width', '100%');
				$('.maxx-intelligence-details-container').css('height', '100%');
			} else {
				// Contract
				isExpanded = false;

				$icon.removeClass('fa-compress-alt').addClass('fa-expand-alt');
				$icon.attr('title', 'Expand');
				$icon.attr('data-original-title', 'Expand');

				$contents.css({
					position: '',
					top     : '',
					left    : '',
					width   : '',
					height  : '',
					zIndex  : ''
				});

				$('.chatbot-entry').css('width', '445px');
				$('.maxx-intelligence-details-container').css('height', '100%');
			}

			// Reset the tooltip
			$icon.tooltip('destroy').tooltip();
		});

		// Add click event handler for chatbot type buttons
		$('.chatbot-type').on('click', function _chatBotTypeClicked() {
			var $this = $(this),
				type  = $this.data('type');

			// Remove active styles from all .chatbot-type elements
			$('.chatbot-type').removeClass('chatbot-type-active');

			// Add active styles to the clicked element
			$this.addClass('chatbot-type-active');

			if (type === 'ask-maxx') {
				$('.chatbot-ask-maxx-container').show();
				$('.chatbot-maxx-intelligence-container').hide();

				$this.css({
					color                : greenColor,  // Use greenColor variable
					'border-bottom-color': greenColor  // Use greenColor variable
				});

				mode = 'ask-maxx';

				$('.chatbot-specificity').html('');
			} else if (type === 'maxx-intelligence') {

				$this.css({
					color                : blueColor,  // Use blueColor variable
					'border-bottom-color': blueColor  // Use blueColor variable
				});

				$('.chatbot-ask-maxx-container').hide();
				$('.chatbot-maxx-intelligence-container').show();

				mode = 'maxx-intelligence';

				showMaxxIntelligence();

				$('.chatbot-specificity').html(`<div class="maxx-intelligence-options">
						<div class="maxx-intelligence-option">
							<button class="maxx-intelligence-option-button active" data-option="generate">Generate Content</button>&nbsp;
							<button class="maxx-intelligence-option-button" data-option="history">History</button>
						</div>
					</div>`);
			}
		});

		// starts ask maxx ui
		$('.ask-maxx-start').on('click', function _chatBotAskMaxxStart() {
			// show the details container
			$('.chatbot-details-container').show();
			$('.ask-maxx-card-intro').hide();

			setSpecificity('concise');
		});

		// starts maxx intelligence ui
		$('.maxx-intelligence-start').on('click', function _chatBotMaxxIntelligenceStart() {
			$('.maxx-intelligence-details-container').show();
			$('.maxx-intelligence-card-intro').hide();

			if ($('#maxx-intelligence-session-id').val() === '') {
				// if there's no session id set for maxx intelly, set it
				setMaxxIntelligenceSessionId();

				// if it's the first time, show a random intro
				maxxBubble(getRandomIntro());
			}
		});

		// sends the request to the maxx intelligence system
		$('#maxx-intelligence-submit').on('click', function _chatBotSubmit() {
			var maxxIntelligenceMessage = $('#maxx-intelligence-entry').val();

			if (maxxIntelligenceMessage === '') {
				maxxIntelligenceAsked = false;
				maxxBubble(alertIcon + ' I\'ll need you to ask a question first so that I can dig up the answer!', '', false, true);	

				scrollContents($('.maxx-intelligence-response'));
			} else {
				sendMaxxIntelligence(maxxIntelligenceMessage);
			}
		});

		// Add click event handler for chatbot choice buttons
		// (No-op: topic selection is handled internally by Bedrock — kept for any
		//  future UI that might want to pass a hint to the gateway.)
		$('.chatbot-container').on('click', '.chatbot-choice', function _chatBotChoiceClicked() {
			$(this).addClass('chatbot-choice-active');
			$('.chatbot-choice').not(this).removeClass('chatbot-choice-active');
		});

		// Add click handler for the followup bubbles
		$('.chatbot-container').on('click', '.chatbot-followup-bubble', function _followupBubbleClick() {
			var followupQuestion = $(this).data('followup');

			$('#chatbot-entry').val(followupQuestion);
			$('#chatbot-submit').click();
		});

		// show the chat window or the history window
		$('.chatbot-container').on('click', '.maxx-intelligence-option-button', function _maxxIntelligenceOptionButtonClicked() {
			var $this  = $(this),
				option = $this.data('option');

			$('.maxx-intelligence-option-button').removeClass('active');
			$(this).addClass('active');

			if (option === 'generate') {
				$('.maxx-intelligence-response').show();
				$('.maxx-intelligence-history').hide();
			} else if (option === 'history') {
				$('.maxx-intelligence-response').hide();
				$('.maxx-intelligence-history').show();
				loadMaxxIntelligenceHistory();
			}
		});

		// Add click event handler for microphone icons
		$('.chatbot-microphone').on('click', function _chatBotMicrophoneClicked() {
			$(this).toggleClass('active');
			if ($(this).hasClass('active')) {
				textToSpeech();
			} else if (window.recognition) {
				window.recognition.stop();
			}
		});

		// adds the last question into the question box
		$('.chatbot-container').on('click', '.ask-again', function _askMaxxAgain(e) {
			var question = $(this).data('question');

			e.preventDefault();

			$('#chatbot-entry').val(question);
		});

		$('.chatbot-container').on('click', '.chatbot-ask-again', function _askMaxxAgain(e) {
			var question = $(this).data('question');

			e.preventDefault();

			if (mode === 'ask-maxx') {
				$('#chatbot-entry').val(question);
			} else {
				$('#maxx-intelligence-entry').val(question);
			}
		});

		// triggers the drop down if the topic is clicked
		$('.chatbot-container').on('click', '.topic-label', function _topicLabelClicked(e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('.chatbot-topics-label-wrapper').find('.dropdown-toggle').dropdown('toggle');
		});

		$('.chatbot-container').on('click', '.animate-border', function _topicLabelClicked(e) {
			e.preventDefault();
			e.stopPropagation();
			$(this).closest('.chatbot-topics-label-wrapper').find('.dropdown-toggle').dropdown('toggle');
		});

		// if the backdrop is clicked, hide the chatbot
		$('body').on('click', '.chatbot-backdrop', function _backdropClicked() {
			hideChatBot();
		});

		$('.chatbot-container').on('click', '.feedback-button-yes', function _feedbackButtonYesClicked() {
			askMaxxquestionAsked = false;
			lastAnswerBad        = true;

			maxxBubble('Fur-tastic! 🐾 Please add your thoughts in the input field highlighted in red below.', 'BAD', false);
			
			// we're going to modify the text input field to have a different background color and placeholder
			$('#chatbot-entry').css('background-color', '#ffcccc');
			$('#chatbot-entry').attr('placeholder', 'Type your feedback here...');
			$('#chatbot-entry').addClass('feedback-input');

			// hide the feedback buttons
			$('.feedback-button-yes').addClass('hidden');
			$('.feedback-button-no').addClass('hidden');

			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.feedback-button-no', function _feedbackButtonNoClicked() {
			// Send feedback data to the server
			Adzuki.Ajax.post('/Ai/sendFeedback/', badQuestionDetails)
				.then(() => {
					// Hide feedback buttons
					$('.feedback-button-yes, .feedback-button-no').addClass('hidden');

					// Reset state and display message
					lastAnswerBad = false;
					const message = 'No problem at all. If you ever want to share, I\'m all ears! Feel free to keep those questions coming! 🐶✨';
					maxxBubble(message, '', false);
					scrollContents($('.chatbot-response'));
				})
				.catch(error => {
					console.error('Error sending feedback:', error);
					// Handle error (e.g., show error message to user)
				});
		});

		$('.chatbot-container').on('click', '.feedback-thumbs-up', function _thumbsUpClicked() {
			// Reset both thumbs to default color
			$(this).closest('.chatbot-feedback').find('i').css('color', '#CCC');

			$(this).find('i').css('color', greenColor);

			askMaxxquestionAsked = false;
			maxxBubble( 'Pawsome! 🐶 Your feedback helps me wag my tail even more. If you need anything else, just give me a bark!', 'GOOD', false);
			askMaxxquestionAsked = true;
			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.feedback-thumbs-down', function _thumbsDownClicked() {
			var $this           = $(this),
				chatBotReplyId  = $this.data('chatbot-reply-id'),
				question        = $this.data('question'),
				$obj            = $(`#${chatBotReplyId}`),
				response        = stripHtmlAndFormat($obj.html().trim()),
				// MAXX-170: no question/response on these buttons — nothing reads
				// them (the handlers use badQuestionDetails), and the bubble's
				// sanitizeHTML linkifies URLs inside attribute text, breaking it
				feedbackButtons = `<br><br>
					<button class="btn btn-primary feedback-button-yes" data-chatbot-reply-id="${chatBotReplyId}">Yes</button> 
					<button class="btn btn-primary feedback-button-no" data-chatbot-reply-id="${chatBotReplyId}">No</button>
				`;

			// Reset both thumbs to default color
			$(this).closest('.chatbot-feedback').find('i').css('color', '#CCC');

			// set the color to red
			$(this).find('i').css('color', '#dc3545');

			// set the details of the feedback request
			badQuestionDetails = {
				session_id : $('#chatbot-session-id').val(),
				question   : question,
				response   : response,
				endpoint   : 'bedrock/askmaxx',
				explanation: null
			};

			// sets the vars so we know that it's not a traditional request
			askMaxxquestionAsked = false;
			lastAnswerBad        = true;
			
			maxxBubble('Ruff! 🐾 Thanks for the feedback. I\'ll work on fetching better responses.  Would you provide input on what was wrong with the response?' + feedbackButtons, '', false);

			// Clear the suggestions
			$('.chatbot-specificity').html('');

			// scrolls the content
			scrollContents($('.chatbot-response'));
		});

		$('.chatbot-container').on('click', '.chatbot-save-conversation', function _saveConversation() {
			var conversation        = collectChatbotConversation();
			var sessionId           = $('#chatbot-session-id').val();
			var saveConversationUrl = Adzuki.erez_url + Adzuki.base_uri + '/Ai/askMaxxHistory';
			
			if (askMaxxquestionAsked === false && lastAnswerBad === false) {
				maxxBubble(alertIcon + ' Saving conversation will be available after your first question is asked.', '', false, true);	
				scrollContents($('.chatbot-response'));
				return;
			}

			// Example: Send to server
			Adzuki.Ajax.post('/Ai/saveConversation/', {
				conversation: JSON.stringify(conversation),
				sessionId   : sessionId
			}).then(function _processResponse(response) {
				// Handle the response from the server
				askMaxxquestionAsked = false;

				maxxBubble(`Woof! 🐾 I've added this to your saved conversations! To view all your saved conversations, visit the Artificial Intelligence History in the Operations Hub or click <b><a href="${saveConversationUrl}" target="_blank">here</a></b>!`, 'SAVED', false);
				scrollContents($('.chatbot-response'));
				askMaxxquestionAsked = true;
			}).catch(function _trapError(error) {
				console.error('Error saving conversation:', error);
				Adzuki.StatusMessage('Error', 'Failed to save the conversation. Please try again.');
			});
		});

		// trigger ask maxx from mobile index (main->mobileIndex)
		$('.mobile-ask-maxx').on('click', function _showMaxx(e) {
			e.preventDefault();

			showChatBot();
		});

		// trigger ask maxx with a pre-set question (rendered via the AskMaxxTrigger element)
		// delegated on document so buttons injected into modals/ajax content still work
		$(document).on('click', '.ask-maxx-trigger', function _askMaxxTrigger(e) {
			var question = $(this).data('ask-maxx-question') || '',
				$modal   = $(this).closest('.modal');

			e.preventDefault();

			// no-op if this page doesn't render the chatbot
			if ($('.chatbot-container').length === 0) {
				return;
			}

			function _openAndAsk() {
				// make sure we're on the Ask Maxx tab, not Maxx Intelligence
				if (mode !== 'ask-maxx') {
					$('.chatbot-type[data-type="ask-maxx"]').trigger('click');
				}

				// only open if it's not already showing, otherwise we'd stack backdrops
				if ($('.chatbot-contents').hasClass('hidden')) {
					showChatBot();
				}

				// skip the intro card if it's still showing
				if ($('.ask-maxx-card-intro').is(':visible')) {
					$('.ask-maxx-start').trigger('click');
				}

				$('#chatbot-entry').val(question);
				$('#chatbot-submit').trigger('click');
			}

			// wait for an open modal to finish hiding so its backdrop/scroll-lock
			// doesn't fight with the chatbot's own backdrop
			if ($modal.length > 0 && $modal.hasClass('in')) {
				$modal.one('hidden.bs.modal', _openAndAsk);
				$modal.modal('hide');
			} else {
				_openAndAsk();
			}
		});
	});

	// --- local functions ---

	// advisor bubble
	function advisorBubble(message) {
		// const timestamp = new Date().toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
		// MAXX-170: the advisor's words are text, never markup — this bubble
		// also replays stored questions when a conversation is resumed
		const formattedDiv = `
			<div class="chatbot-user-label ${isDarkMode ? 'theme--dark' : ''}">${$('#chatbot-agent-name').val()}</div>
			<div class="chatbot-user-question ${mode === 'maxx-intelligence' ? 'maxx-intelligence' : ''}">
				${formatAdvisorText(message)}
			</div>
			<div class="clearfix"></div>
		`;

		if (mode === 'ask-maxx') {
			$('.chatbot-response').append(formattedDiv);
		} else {
			$('.maxx-intelligence-response').append(formattedDiv);
		}
	}

	// collect chatbot conversation information
	function collectChatbotConversation() {
		var conversation     = [];
		var $chatbotResponse = $('.chatbot-response');
		var $element;
		var replyId;
		var $referencesContainer;
		var references;
		var $reference;
		var topic;

		$chatbotResponse.children().each(function _iterateBubbles(index, element) {
			$element = $(element);
			if ($element.hasClass('chatbot-user-question')) {
				conversation.push({
					type   : 'user',
					message: $element.text().trim()
				});
			} else if ($element.hasClass('chatbot-bot-reply')) {
				replyId              = $element.attr('id');
				$referencesContainer = $('#ref-container-' + replyId);
				references           = [];
				topic                = $element.data('topic');

				if ($referencesContainer.length > 0) {
					$referencesContainer.find('.chatbot-reference-bedrock').each(function _iterateBedrockReferences() {
						$reference = $(this);
						references.push({
							url     : $reference.find('.ref-url').attr('href') || null,
							title   : $reference.find('.ref-url').text().trim(),
							subtitle: $reference.find('.ref-subtitle').text().trim() ||
								$reference.find('.kb-tag').text().trim(),
							image: $reference.find('.ref-image img').attr('src') || null,
						});
					});

					if (references.length === 0) {
						$referencesContainer.find('.chatbot-reference').each(function _iterateLegacyReferences() {
							$reference = $(this);
							references.push({
								url     : $reference.find('a').attr('href'),
								title   : $reference.find('a span:not(.reference-subtitle)').text().trim(),
								subtitle: $reference.find('.reference-subtitle').text().trim(),
								image   : $reference.find('img').attr('src') || null,
							});
						});
					}
				}

				if ($element.find('.chatbot-topic-label').length > 0) {
					topic = $element.find('.chatbot-topic-label').text().replace(/^Topic:\s*/i, '').trim();
				}

				conversation.push({
					type      : 'bot',
					// MAXX-174: stored without the Export CSV buttons
					message   : exportFreeHtml($element).trim(),
					id        : replyId,
					references: references,
					topic     : topic || 'Unknown'
				});
			}
		});

		return conversation;
	}

	function copyResponseToClipboard($obj)
	{
		var responseText = exportFreeHtml($obj);

		// Check if $obj is valid and has content
		if ($obj.length === 0 || !responseText) {
			console.error('Invalid object or empty response');
			Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard.');
			return;
		}

		function listener(e) {
			e.clipboardData.setData("text/html", responseText);
			e.clipboardData.setData("text/plain", responseText);
			e.preventDefault();
		}

		try {
			document.addEventListener("copy", listener);
			document.execCommand("copy");
			document.removeEventListener("copy", listener);

			askMaxxquestionAsked  = false;
			maxxIntelligenceAsked = false;

			if (mode === 'ask-maxx') {
				maxxBubble('Woof! 🐾 I\'ve copied your response to the clipboard!', '', false);
				scrollContents($('.chatbot-response'));
			} else {
				if ($('.maxx-intelligence-option-button.active').data('option') === 'history') { // eslint-disable-line no-lonely-if
					Adzuki.StatusMessage('Success', 'Copied to clipboard');
				} else {
					maxxBubble('Woof! 🐾 I\'ve copied your response to the clipboard!', '', false);
					scrollContents($('.maxx-intelligence-response'));
				}
			}
		} catch (err) {
			console.error('Unable to copy to clipboard', err);
			Adzuki.StatusMessage('Error', 'Failed to copy response to clipboard.');
			return;
		}
	}

	function disableChatbotEntry()
	{
		$('#chatbot-entry').val('')
		.prop('disabled', true);

		$('#chatbot-submit').prop('disabled', true);
	}

	function enableChatbotEntry()
	{
		var isAndroid = (/android/i).test(navigator.userAgent.toLowerCase());

		if (isAndroid) {
			$('#chatbot-entry').val('')
			.prop('disabled', false);
		} else {
			$('#chatbot-entry').val('')
			.prop('disabled', false)
			.trigger('focus');
		}

		$('#chatbot-submit').prop('disabled', false);
	}


	function isMarkdownTableRow(line)
	{
		var trimmed = String(line).trim();

		return trimmed.indexOf('|') !== -1 && (/^\|/).test(trimmed);
	}

	function isMarkdownTableSeparator(line)
	{
		var trimmed = String(line).trim();

		return trimmed.indexOf('-') !== -1 && (/^\|?[\s:|-]+\|?$/).test(trimmed);
	}

	function parseMarkdownTableRow(line)
	{
		var trimmed = String(line).trim();
		var cells     = [];
		var current   = '';
		var urlDepth  = 0;
		var i;
		var ch;

		if (trimmed.charAt(0) === '|') {
			trimmed = trimmed.substring(1);
		}

		if (trimmed.charAt(trimmed.length - 1) === '|') {
			trimmed = trimmed.substring(0, trimmed.length - 1);
		}

		for (i = 0; i < trimmed.length; i++) {
			ch = trimmed.charAt(i);

			if (ch === '(' && current.charAt(current.length - 1) === ']') {
				urlDepth = 1;
				current += ch;
			} else if (urlDepth > 0) {
				if (ch === '(') {
					urlDepth += 1;
				} else if (ch === ')') {
					urlDepth -= 1;
				}

				current += ch;
			} else if (ch === '|') {
				cells.push(current.trim());
				current = '';
			} else {
				current += ch;
			}
		}

		cells.push(current.trim());

		return cells;
	}

	/**
	 * Build the anchor for a markdown link. Expects HTML-escaped input (see
	 * formatResponse), so the url can't break out of the href attribute.
	 * Script-style schemes render as plain label text.
	 */
	function buildMarkdownAnchor(linkText, url)
	{
		var href = String(url).trim();

		if ((/^(?:javascript|vbscript|data):/i).test(href.replace(/\s+/g, ''))) {
			return linkText;
		}

		if (isMobileDevice()) {
			href = 'inapp://chatbot/' + href;
		}

		return '<a href="' + href + '" target="_blank">' + linkText + '</a>';
	}

	function formatMarkdownLinks(text)
	{
		var formatted = String(text);

		// [text](<url>) — the angle brackets arrive escaped
		formatted = formatted.replace(
			/\[([^\]]+)\]\(\s*&lt;(.+?)&gt;\s*\)/g,
			function _formatAngleLink(match, linkText, url) {
				return buildMarkdownAnchor(linkText, url);
			}
		);

		return formatted.replace(
			/\[([^\]]+)\]\(\s*([^\)]+?)\s*\)/g,
			function _formatLink(match, linkText, url) {
				return buildMarkdownAnchor(linkText, url);
			}
		);
	}

	/**
	 * **bold** and *italic*. Runs before newlines become <br>, so neither
	 * can span lines, and a "* " list bullet is never read as an opener.
	 */
	function formatInlineEmphasis(text)
	{
		return String(text)
			.replace(/\*\*(?=\S)([^\n]*?\S)\*\*/g, '<b>$1</b>')
			.replace(/(^|[^\w*])\*(\S(?:[^*\n]*?\S)?)\*(?![\w*])/gm, '$1<i>$2</i>');
	}

	function formatTableCellContent(cell)
	{
		var content = String(cell).trim();

		content = formatMarkdownLinks(content);

		if (!((/<a\s/i).test(content))) {
			content = content.replace(
				/(\b(?:https?:\/\/)?[\w.-]+\/(?:CruiseSearch\/(?:viewMinimal|view)|sailing)\/[^\s<>"')\],|]+)/gi,
				function _wrapPlainCruiseUrl(url) {
					var href = url;

					if (href.indexOf('://') === -1) {
						href = 'http://' + href;
					}

					return '<a href="' + href + '" target="_blank">' + url + '</a>';
				}
			);
		}

		content = formatInlineEmphasis(content);

		return content;
	}

	function convertMarkdownTableToHtml(tableLines)
	{
		var headerCells = parseMarkdownTableRow(tableLines[0]);
		var bodyLines   = tableLines.slice(2);
		var html        = '<div class="chatbot-table-wrapper"><table class="chatbot-table"><thead><tr>';

		headerCells.forEach(function _appendHeaderCell(cell) {
			html += '<th>' + formatTableCellContent(cell) + '</th>';
		});
		html += '</tr></thead><tbody>';

		bodyLines.forEach(function _appendBodyRow(rowLine) {
			var cells = parseMarkdownTableRow(rowLine);

			html += '<tr>';
			cells.forEach(function _appendBodyCell(cell) {
				html += '<td>' + formatTableCellContent(cell) + '</td>';
			});
			html += '</tr>';
		});

		html += '</tbody></table></div>';

		return html;
	}

	function formatMarkdownTables(text)
	{
		var lines      = String(text).split(/\r\n|\r|\n/);
		var output     = [];
		var tableLines = [];
		var i          = 0;

		while (i < lines.length) {
			if (
				isMarkdownTableRow(lines[i])
				&& i + 1 < lines.length
				&& isMarkdownTableSeparator(lines[i + 1])
			) {
				tableLines = [lines[i], lines[i + 1]];

				i += 2;
				while (i < lines.length && isMarkdownTableRow(lines[i])) {
					tableLines.push(lines[i]);
					i += 1;
				}

				output.push(convertMarkdownTableToHtml(tableLines));
			} else {
				output.push(lines[i]);
				i += 1;
			}
		}

		return output.join('\n');
	}

	function parseMarkdownLinkFromCell(cell)
	{
		var content = String(cell).trim();
		var match;

		match = (/\[([^\]]+)\]\(\s*<([^>]+)>\s*\)/).exec(content);

		if (match) {
			return {
				label: match[1].trim(),
				href : match[2].trim(),
			};
		}

		match = (/\[([^\]]+)\]\(\s*([^\)]+?)\s*\)/).exec(content);

		if (match) {
			return {
				label: match[1].trim(),
				href : match[2].trim(),
			};
		}

		match = (/(\b(?:https?:\/\/)?[\w.-]+\/(?:CruiseSearch\/(?:viewMinimal|view)|sailing)\/[^\s<>"')\],|]+)/i).exec(content);

		if (match) {
			return {
				label: content.replace(match[1], '').trim() || match[1],
				href : match[1].trim(),
			};
		}

		return null;
	}

	function extractTableCellLinksFromMarkdown(text)
	{
		var lines      = String(text).split(/\r\n|\r|\n/);
		var results    = [];
		var i          = 0;
		var bodyRowIdx;
		var cells;
		var link;
		var colIdx;

		while (i < lines.length) {
			if (
				isMarkdownTableRow(lines[i])
				&& i + 1 < lines.length
				&& isMarkdownTableSeparator(lines[i + 1])
			) {
				i += 2;
				bodyRowIdx = 0;

				while (i < lines.length && isMarkdownTableRow(lines[i])) {
					cells = parseMarkdownTableRow(lines[i]);

					for (colIdx = 0; colIdx < cells.length; colIdx++) {
						link = parseMarkdownLinkFromCell(cells[colIdx]);

						if (link && link.href) {
							results.push({
								rowIndex: bodyRowIdx,
								colIndex: colIdx,
								href    : link.href,
								label   : link.label,
							});
						}
					}

					bodyRowIdx += 1;
					i += 1;
				}
			} else {
				i += 1;
			}
		}

		return results;
	}

	function buildTableLinkTargetsFromChunks(chunks, references)
	{
		var targets      = [],
			chunk,
			indexedUrl,
			ref,
			url,
			metadata,
			pageContent,
			labels,
			match,
			dateRegex,
			i;

		if (!chunks || !chunks.length) {
			return targets;
		}

		dateRegex = /(?:Jan(?:uary)?|Feb(?:ruary)?|Mar(?:ch)?|Apr(?:il)?|May|Jun(?:e)?|Jul(?:y)?|Aug(?:ust)?|Sep(?:t(?:ember)?)?|Oct(?:ober)?|Nov(?:ember)?|Dec(?:ember)?)\.?\s+\d{1,2},?\s+\d{4}/gi;

		for (i = 0; i < chunks.length; i++) {
			chunk      = chunks[i];
			indexedUrl = getChunkIndexedUrl(chunk);
			ref        = indexedUrl ? getReferenceForUrl(references, indexedUrl) : null;
			url        = '';

			if (ref && ref.url) {
				url = ref.url;
			} else if (chunk.source_url) {
				url = chunk.source_url;
			} else if (indexedUrl) {
				url = indexedUrl;
			}

			if (!url) {
				continue;
			}

			labels      = [];
			metadata    = chunk.metadata || {};
			pageContent = chunk.pageContent || chunk.page_content || '';

			if (metadata.title) {
				labels.push(String(metadata.title).trim());
			}

			if (ref && ref.title) {
				labels.push(String(ref.title).trim());
			}

			match = (/\[([^\]]+)\]\(\s*([^\)]+?)\s*\)/).exec(pageContent);

			if (match) {
				labels.push(match[1].trim());
			}

			match = dateRegex.exec(pageContent);
			while (match !== null) {
				labels.push(match[0].trim());
				match = dateRegex.exec(pageContent);
			}

			labels = labels.filter(function _uniqueLabel(value, index, list) {
				return value && value.length >= 3 && list.indexOf(value) === index;
			});

			if (labels.length === 0) {
				continue;
			}

			targets.push({
				url   : url,
				labels: labels,
			});
		}

		return targets;
	}

	function findBestTableLinkTarget(cellText, targets)
	{
		var normalizedCell = String(cellText).trim().toLowerCase();
		var bestMatch      = null;
		var bestScore      = 0;
		var target,
			label,
			normalizedLabel,
			score,
			i,
			j;

		if (!normalizedCell) {
			return null;
		}

		for (i = 0; i < targets.length; i++) {
			target = targets[i];

			for (j = 0; j < target.labels.length; j++) {
				label            = target.labels[j];
				normalizedLabel  = String(label).trim().toLowerCase();
				score            = 0;

				if (normalizedCell === normalizedLabel) {
					score = 100;
				} else if (
					normalizedCell.indexOf(normalizedLabel) !== -1 ||
					normalizedLabel.indexOf(normalizedCell) !== -1
				) {
					score = Math.min(normalizedCell.length, normalizedLabel.length);
				}

				if (score > bestScore) {
					bestScore = score;
					bestMatch = target;
				}
			}
		}

		return bestScore >= 4 ? bestMatch : null;
	}

	function applyTableLinksFromRawMarkdown(rawAnswer, replyId)
	{
		var cellLinks = extractTableCellLinksFromMarkdown(rawAnswer),
			$bubble   = $('#' + replyId + '.chatbot-bot-reply').first(),
			$table,
			link,
			$row,
			$cell,
			$anchor,
			label,
			i;

		if (!cellLinks.length || !$bubble.length) {
			return;
		}

		$table = $bubble.find('.chatbot-table tbody').first();

		if (!$table.length) {
			return;
		}

		for (i = 0; i < cellLinks.length; i++) {
			link = cellLinks[i];
			$row  = $table.find('tr').eq(link.rowIndex);
			$cell = $row.find('td').eq(link.colIndex);

			if (!$cell.length || !link.href) {
				continue;
			}

			$anchor = $cell.find('a').first();

			if ($anchor.length) {
				if (!$anchor.attr('href') || $anchor.attr('href') === '#') {
					$anchor.attr('href', link.href);
				}

				continue;
			}

			label = $cell.text().trim() || link.label || link.href;
			$cell.html('<a href="' + escapeHtml(link.href) + '" target="_blank">' + escapeHtml(label) + '</a>');
		}
	}

	function applyTableLinksFromChunks(replyId, chunks, references)
	{
		var targets   = buildTableLinkTargetsFromChunks(chunks, references),
			$bubble   = $('#' + replyId + '.chatbot-bot-reply').first(),
			cellText,
			match;

		if (!targets.length || !$bubble.length) {
			return;
		}

		$bubble.find('.chatbot-table td').each(function _applyChunkLink() {
			var $cell = $(this);

			if ($cell.find('a').length) {
				return;
			}

			cellText = $cell.text().trim();

			if (!cellText) {
				return;
			}

			match = findBestTableLinkTarget(cellText, targets);

			if (match && match.url) {
				$cell.html('<a href="' + escapeHtml(match.url) + '" target="_blank">' + escapeHtml(cellText) + '</a>');
			}
		});
	}

	// Function to format the response
	function formatResponse(response) {
		// Escape first so raw HTML from the model renders as text, then
		// normalize line endings for the line-based passes below
		let formattedResponse = escapeHtml(response).replace(/\r\n|\r/g, '\n');

		// Build tables first while row markdown is intact, formatting links inside cells
		formattedResponse = formatMarkdownTables(formattedResponse);

		// Convert any remaining markdown links outside of table cells
		formattedResponse = formatMarkdownLinks(formattedResponse);

		// Replace ### headings with <h4> tags (the h4 is its own line break)
		formattedResponse = formattedResponse.replace(/^[ \t]*#{1,6}[ \t]+(.*?)[ \t#]*(?:\n|$)/gm, '<h4>$1</h4>');

		// **bold** / *italic*
		formattedResponse = formatInlineEmphasis(formattedResponse);

		// Replace newlines with <br> tags
		formattedResponse = formattedResponse.replace(/\n/g, '<br>');

		return formattedResponse;
	}

	/**
	 * MAXX-170: index in a partially streamed line where markdown opens but
	 * hasn't closed yet (bold, italic, or a link) — everything from there on
	 * is held back so the reader never sees raw symbols. Returns the line
	 * length when nothing is open.
	 */
	function findOpenInlineMarkdown(line)
	{
		var boldAt   = -1;
		var italicAt = -1;
		var linkAt   = -1;
		var urlDepth = 0;
		var i        = 0;
		var ch;
		var next;

		while (i < line.length) {
			ch   = line.charAt(i);
			next = line.charAt(i + 1);

			if (linkAt !== -1) {
				if (urlDepth > 0) {
					if (ch === '(') {
						urlDepth += 1;
					} else if (ch === ')') {
						urlDepth -= 1;

						if (urlDepth === 0) {
							linkAt = -1;
						}
					}
				} else if (ch === ']') {
					if (next === '(') {
						urlDepth = 1;
						i += 2;
						continue;
					}

					// "]" followed by anything but "(" is a plain bracket; a
					// trailing "]" stays open until the next character lands
					if (next !== '') {
						linkAt = -1;
					}
				}

				i += 1;
				continue;
			}

			if (ch === '[') {
				linkAt = i;
			} else if (ch === '*' && next === '*') {
				boldAt = (boldAt === -1) ? i : -1;
				i += 2;
				continue;
			} else if (ch === '*') {
				if (italicAt !== -1) {
					italicAt = -1;
				} else if (next === '' || ((/\S/).test(next) && !(/\w/).test(line.charAt(i - 1)))) {
					// a trailing "*" may be the first half of "**"
					italicAt = i;
				}
			}

			i += 1;
		}

		return [boldAt, italicAt, linkAt].reduce(function _earliest(cut, at) {
			return (at !== -1 && at < cut) ? at : cut;
		}, line.length);
	}

	/**
	 * MAXX-170: trim a partially streamed answer down to the markdown that is
	 * complete, so it can go through formatResponse on every paint.
	 *  - complete lines render as-is
	 *  - a table renders once its header + separator lines have arrived, then
	 *    gains each row as that row's line completes
	 *  - the line still being typed renders up to its first unclosed marker;
	 *    a heading or table row in progress is held until its line completes
	 */
	function getStreamingRenderableText(text)
	{
		var lines      = String(text).replace(/\r\n|\r/g, '\n').split('\n');
		var lastLine   = lines.pop();
		var tableStart = lines.length;
		var block;
		var visible;

		// Trailing complete table lines only render once the table is established
		while (tableStart > 0 && isMarkdownTableRow(lines[tableStart - 1])) {
			tableStart -= 1;
		}

		if (tableStart < lines.length) {
			block = lines.slice(tableStart);

			if (block.length < 2 || !isMarkdownTableSeparator(block[1])) {
				lines    = lines.slice(0, tableStart);
				lastLine = '';
			}
		}

		if ((/^\s*[|#]/).test(lastLine)) {
			visible = '';
		} else {
			visible = lastLine.substring(0, findOpenInlineMarkdown(lastLine));
		}

		if (visible === '') {
			return lines.join('\n');
		}

		return lines.concat([visible]).join('\n');
	}

	// Function to generate a random string of 25 characters
	function generateRandomString() {
		// Define the set of characters to choose from
		var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789',
			i      = 0,
			result = '';

		// Loop 25 times to create a 25-character string
		for (i = 0; i < 25; i++) {
			// Append a random character from the 'characters' string to the result
			result += characters.charAt(Math.floor(Math.random() * characters.length));
		}
		// Return the generated random string
		return result;
	}

	// get random intro
	function getRandomIntro() {
		const randomIndex = Math.floor(Math.random() * intros.length);
		var intro = '';

		if (mode === 'ask-maxx') {
			intro = intros[randomIndex];
		} else {
			intro = intelligenceIntros[randomIndex];
		}

		return intro;
	}

	// hide chatbot
	function hideChatBot() {
		var $icon     = $('.chatbot-expand').find('i').first();
		var $contents = $('.chatbot-contents');

		// Hide and reset main containers
		$('.chatbot-contents')
			.slideUp()
			.addClass('hidden');
		$('.chatbot-references').addClass('hidden');

		// Remove backdrop
		$('.chatbot-backdrop').fadeOut(function _removeBackdrop() {
			$(this).remove();
		});

		// Clear content
		// $('.chatbot-response, .chatbot-references').empty();

		// Reset input and specificity
		$('#chatbot-entry').val('');
		resetSpecificityOption();

		// Show the chatbot logo container
		$('.chatbot-logo-container').show();

		// Reset the size and icon state
		$icon.removeClass('fa-compress-alt').addClass('fa-expand-alt');
		$icon.attr('title', 'Expand');

		// Remove all inline styles from .chatbot-contents
		$contents.removeAttr('style');

		// IF they had started providing feedback, and bailed, then reset the variables
		$('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
		$('#chatbot-entry').removeClass('feedback-input');
		lastAnswerBad = false;

		// Reset specific elements
		if (isIOS || isIpadOS) {
			$('.chatbot-entry').css('width', 'auto');
		} else {
			$('.chatbot-entry').css('width', '445px');
		}

		$('.maxx-intelligence-details-container').css('height', '100%');

		// Reset the tooltip
		$icon.tooltip('destroy').tooltip();
	}

	function isMobileDevice() {
	    return (/android/i).test(navigator.userAgent.toLowerCase()) || 
	           (/iPhone|iPad|iPod/).test(navigator.userAgent) || 
	           (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform));
	}	

	function isIOS() {
		if ((/iPad|iPhone|iPod/).test(navigator.platform)) {
		    return true;
		}
		return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform);
	}

	function isIpadOS() {
      return navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && (/MacIntel/).test(navigator.platform);
	}

	function loadChoices() 
	{
		var $choicesContainer = $('.chatbot-choices-container');

		$choicesContainer.empty();

		// Header with save conversation button — topic picker removed (Bedrock routes internally)
		$choicesContainer.append(
			'<div class="chatbot-header-container">'
				+ '<div class="chatbot-save-conversation" data-toggle="tooltip" '
					+ 'title="This will save your current conversation with Maxx" '
					+ 'data-session-id="' + $('#chatbot-session-id').val() + '">'
					+ '<i class="fas fa-save" aria-hidden="true"></i> Save Conversation'
				+ '</div>'
			+ '</div>'
		);
	}

	function toggleTopicLabelAnimation(shouldAnimate) {
		$('.chatbot-topics-label-wrapper').toggleClass('animate-border', shouldAnimate);

		if (shouldAnimate) {
			$('.topic-arrow').removeClass('hidden');
		} else {
			$('.topic-arrow').addClass('hidden');
		}
	}

	function loadMaxxIntelligenceHistory()
	{
		Adzuki.Ajax.get('/Ai/gptHistory/0/1').then(function success(content) {
			var historyHtml = '';

			content.conversations.forEach(function _iterateConversations(item, index) {
				var historyItemId = 'history-item-' + index;
				historyHtml += `
					<div class="history-item" id="${historyItemId}">
						<div class="history-date">${escapeHtml(item.created)}</div>
						<div class="history-prompt">
							<strong>Prompt:</strong>
							<p>${formatAdvisorText(item.prompt)}</p>
						</div>
						<div class="history-response">
							<strong>Response:</strong>
							<p id="history-response-${historyItemId}">${formatResponse(item.response)}</p>
						</div>
						<div class="chatbot-actions">
							<div class="history-copy" data-history-id="${historyItemId}">
								<i class="fa fa-copy" aria-hidden="true"></i> copy response
							</div>
							<div class="history-snippets" data-history-id="${historyItemId}">
								<i class="fa fa-cut" aria-hidden="true"></i> save to snippets
							</div>
						</div>
					</div>
				`;
			});

			$('.maxx-intelligence-history-details').html(historyHtml);
		});
	}

	function logChatbotResponse(endpoint, request, response, exec_time)
	{
		var session_id   = $('#chatbot-session-id').val();
		var request_data = {
			session_id: session_id,
			endpoint  : endpoint,
			exec_time : exec_time,
			request   : JSON.stringify(request),
			response  : JSON.stringify(response),
		};

		Adzuki.Ajax.post('/Ai/logChatbotResponse/', request_data)
		.then(function _logChatbotResponse(response) {
			// response logged, nothing to do here
		});
	}

	// maxx bubble
	function maxxBubble(message, chatbotReplyId, thinking, alertMessage) {
		var isThinking     = (thinking === undefined) ? false : thinking,
			isAlertMessage = (alertMessage === undefined) ? false : alertMessage,
			formattedDiv   = '',
			// The list is shared — Adzuki.MaxxAnimations, js/Adzuki/maxx_animations.js.
			randomImage = (Adzuki.MaxxAnimations)
				? Adzuki.MaxxAnimations.random()
				: Adzuki.base_uri + '/images/maxx-thinking-animation.gif';

		if (isThinking) {
			formattedDiv = `
				<div class="chatbot-animations">
					<div class="animation-container">
						<img src="${randomImage}" class="${isExpanded === true ? 'animated-image-slower' : 'animated-image'}" alt="Maxx thinking">
					</div>
				</div>
			`;

			if (mode === 'ask-maxx') {
				$('.chatbot-response').append(formattedDiv);
			} else {
				$('.maxx-intelligence-response').append(formattedDiv);
			}

			// Force a reflow to ensure the animation starts
			$('.animated-image').width();
		} else {
			formattedDiv = `
				<div class="chatbot-maxx-label ${isDarkMode ? 'theme--dark' : ''}">Maxx</div>
				<div class="chatbot-bot-reply ${isDarkMode ? 'theme--dark' : ''} ${isAlertMessage ? 'chatbot-alert-message' : ''}" id="${chatbotReplyId}">
					${sanitizeHTML(message)}
				</div>
				<div class="clearfix"></div>`;

			if ((mode === 'ask-maxx' && askMaxxquestionAsked === true) || 
				(mode !== 'ask-maxx' && maxxIntelligenceAsked === true)) {
				formattedDiv += `
					<div class="chatbot-actions">
						<div class="chatbot-left-actions">
							${mode === 'ask-maxx' ? `
							<div class="chatbot-feedback">
								<button class="chatbot-action feedback-thumbs-up chatbot-feedback-button" data-toggle="tooltip" title="Like" data-chatbot-reply-id="${chatbotReplyId}" data-question="${escapeHtml(mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion)}"><i class="fas fa-thumbs-up" aria-hidden="true"></i></button>
								<button class="chatbot-action feedback-thumbs-down chatbot-feedback-button" data-toggle="tooltip" title="Dislike" data-chatbot-reply-id="${chatbotReplyId}" data-question="${escapeHtml(mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion)}"><i class="fas fa-thumbs-down" aria-hidden="true"></i></button>
							</div>
							` : ''}
						</div>
						<div class="chatbot-right-actions">
							<div class="chatbot-reply-copy" data-chatbot-reply-id="${chatbotReplyId}">
								<button class="chatbot-action" data-toggle="tooltip" title="Copy content" style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fa fa-copy" aria-hidden="true"></i></button>
							</div>
							${mode === 'maxx-intelligence' ? `
								<div class="chatbot-snippets" data-chatbot-reply-id="${chatbotReplyId}">
									<button class="chatbot-action" data-toggle="tooltip" title="Save to Snippets" style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fa fa-cut" aria-hidden="true"></i></button>
								</div>
							` : ''}
							<div class="chatbot-ask-again" data-chatbot-reply-id="${chatbotReplyId}" data-question="${escapeHtml(mode === 'ask-maxx' ? askMaxxQuestion : maxxIntelligenceQuestion)}">
								<button class="chatbot-action" data-toggle="tooltip" title="Ask Maxx Again"  style="${mode === 'ask-maxx' ? `color:${greenColor}` : `color: ${blueColor}`}"><i class="fas fa fa-question" aria-hidden="true"></i></button>
							</div>
						</div>
					</div>
				`;
			}

			if (mode === 'ask-maxx') {
				$('.chatbot-response').append(formattedDiv);
			} else {
				$('.maxx-intelligence-response').append(formattedDiv);
			}
		}
	}

	function resetSpecificityOption() {
		$('.chatbot-specificity-option-button').removeClass('active');
		$('.chatbot-specificity-option-button[data-specificity="concise"]').addClass('active');
	}

	function restartChatBot()
	{
		let welcomeMessage = 'Welcome back! I\'m ready for your next question.';

		if (mode === 'ask-maxx') {
			welcomeMessage += ' You can ask me about destinations, sailings, our trusted partners, and information from CP Genie. ';
		}

		// Hide the reference header
		$('.chatbot-reference-header').addClass('hidden');

		// Clear and reset the chat response area
		$('.chatbot-response').html('');

		// Clear the suggestions
		if (mode === 'ask-maxx') {
			$('.chatbot-specificity').html('');
		}

		// Clear the references
		$('.chatbot-references').html('');

		// Generate a new session ID
		setSessionId();

		// load the choices
		loadChoices();

		// Display the welcome back message
		askMaxxquestionAsked = false;

		// IF they had started providing feedback, and bailed, then reset the variables
		// $('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');
		lastAnswerBad = false;

		maxxBubble(welcomeMessage);
	}

	function restartMaxxIntelligence()
	{
		// Display a new random intro message
		const introMessage = getRandomIntro();

		// Clear the existing response
		$('.maxx-intelligence-response').html('');

		// Generate a new session ID
		setMaxxIntelligenceSessionId();

		// Display the welcome back message
		maxxIntelligenceAsked = false;
		maxxBubble(introMessage);
	}

	function scrollContents($obj) {
		$obj.animate({
			scrollTop: $obj[0].scrollHeight
		}, 500);
	}

	function sendChatbotStreamedResponse(msg, specificity, ellipsisInterval)
	{
		var session_id    = $('#chatbot-session-id').val();
		var raw_answer    = '';
		var reply_id      = null;
		var exec_time     = Date.now();
		var response      = {};
		var chunks        = [];          // accumulated citation cards
		var topicLabels   = [];          // unique kb labels for MAXX-117
		var searchingTool = null;        // current tool_start tool name (for MAXX-120)
		var source        = null;
		var toolName;
		var badgeLabel;
		var chunk;
		var kbName;
		var meta;
		var streamPaintGeneration   = 0;
		var activeStreamGeneration  = 0;
		var streamDisplayLength     = 0;
		var streamRevealActive      = false;
		var streamPaintedLength     = 0;
		var streamLastPaintAt       = 0;
		var json_payload            = {
			msg      : msg,
			sessionId: session_id,
		};
		var event_options = {
			start  : false,
			payload: JSON.stringify(json_payload),
			headers: {
				'Content-Type': 'application/json',
			}
		};
		var finalUrl = Adzuki.erez_url + Adzuki.base_uri + '/Ai/bedrockChat/';

		function stopStreamReveal()
		{
			streamRevealActive = false;
		}

		function paintStreamingBubble()
		{
			if (streamPaintedLength === streamDisplayLength) {
				return;
			}

			streamPaintedLength = streamDisplayLength;
			streamLastPaintAt   = Date.now();

			updateMaxxBubble(
				getStreamingRenderableText(raw_answer.substring(0, streamDisplayLength)),
				reply_id
			);
		}

		function startStreamReveal()
		{
			if (streamRevealActive) {
				return;
			}

			streamRevealActive = true;

			function tickStreamReveal()
			{
				if (!streamRevealActive || activeStreamGeneration !== streamPaintGeneration) {
					streamRevealActive = false;
					return;
				}

				if (streamDisplayLength >= raw_answer.length) {
					// flush whatever the throttle skipped on the last frames
					paintStreamingBubble();
					streamRevealActive = false;
					return;
				}

				streamDisplayLength = Math.min(
					raw_answer.length,
					streamDisplayLength + Math.max(
						1,
						Math.min(12, Math.ceil((raw_answer.length - streamDisplayLength) / 8))
					)
				);

				// MAXX-170: reformat on a throttle, not every frame, so long
				// answers don't stutter
				if (Date.now() - streamLastPaintAt >= streamPaintIntervalMs) {
					paintStreamingBubble();
				}

				requestAnimationFrame(tickStreamReveal);
			}

			requestAnimationFrame(tickStreamReveal);
		}

		function finalizeStreamingBubble()
		{
			stopStreamReveal();
			streamPaintGeneration += 1;
			streamDisplayLength = raw_answer.length;
			updateMaxxBubble(raw_answer, reply_id);
			// MAXX-174: only now, so a table still arriving gets no button
			addTableExports(reply_id);
		}

		source = new Adzuki.ServerSentEvents(finalUrl, event_options);

		// ── connection opened ────────────────────────────────────────────────
		source.addEventListener('open', function _onOpen(event) {
			reply_id = generateRandomString();

			if (event.responseCode === 200) {
				clearInterval(ellipsisInterval);
				$('.chatbot-animations').remove();
				$('.chatbot-response').removeClass('hidden');

				streamPaintGeneration += 1;
				activeStreamGeneration = streamPaintGeneration;
				streamDisplayLength    = 0;
				streamPaintedLength    = 0;
				streamLastPaintAt      = 0;
				stopStreamReveal();

				// add empty reply bubble — populated as tokens arrive
				maxxBubble('', reply_id, false);

				// MAXX-122: activity badge sits at the bottom of the generated message
				$('.chatbot-response').append(
					'<div class="chatbot-activity-badge" id="chatbot-activity-badge-' + reply_id + '">'
					+ '<i class="fas fa-circle-notch fa-spin"></i> [ Searching... ]</div>'
				);
				moveActivityBadgeBelowReply(reply_id);
			} else {
				source.close();
				maxxBubble(askMaxxErrorRetry, reply_id, false);
				$('.chatbot-animations').remove();
				enableChatbotEntry();
			}
		});

		// ── streaming events ─────────────────────────────────────────────────
		source.addEventListener('message', function _onMessage(event) {
			var message;

			try {
				message = JSON.parse(event.data);
			} catch (e) {
				return;
			}

			// ── text token ──────────────────────────────────────────────────
			if (message.text !== undefined) {
				raw_answer += message.text;
				if (message.text.length > 0 && searchingTool === null && chunks.length === 0) {
					$('#chatbot-activity-badge-' + reply_id).html(
						'<i class="fas fa-circle-notch fa-spin"></i> [ Writing answer... ]'
					);
				}
				if (message.text.length > 0) {
					startStreamReveal();
				}
				return;
			}

			// ── tool_start: agent choosing / executing a tool ───────────────
			if (message.tool_start !== undefined) {
				// Only react once we have the complete tool name (input stops streaming)
				toolName = message.tool_start;
				if (toolName && toolName !== searchingTool) {
					searchingTool = toolName;
					badgeLabel = _toolNameToLabel(toolName);
					$('#chatbot-activity-badge-' + reply_id).html(
						'<i class="fas fa-circle-notch fa-spin"></i> '
						+ (badgeLabel ? '[ Searching "' + badgeLabel + '" ]' : '[ Searching... ]')
					);
				}
				return;
			}

			// ── chunk: retrieved source document ───────────────────────────
			if (message.chunk !== undefined) {
				chunk  = message.chunk;
				kbName = chunk.kb_name || '';
				meta   = kbName in kbMeta ? kbMeta[kbName] : {
					label   : kbName,
					cssClass: 'kb-unknown',
				};

				// MAXX-117: collect unique topic labels
				if (meta.label && topicLabels.indexOf(meta.label) === -1) {
					topicLabels.push(meta.label);
				}

				// MAXX-119: render citation card progressively (this may build
				// the references container — must run before repositioning the
				// badge so the badge can be placed directly above the container)
				addChunkReference(chunk, meta, reply_id);
				chunks.push(chunk);

				// MAXX-122: keep the activity badge just above the references list
				moveActivityBadgeBelowReply(reply_id);

				$('#chatbot-activity-badge-' + reply_id).html(
					'<i class="fas fa-check-circle"></i> Found ' + chunks.length
					+ ' source' + (chunks.length === 1 ? '' : 's')
				);
				return;
			}

			// ── specialist: terminal event ──────────────────────────────────
			if (message.specialist !== undefined) {
				source.close();

				exec_time = (Date.now() - exec_time) / 1000;

				enableChatbotEntry();

				if (raw_answer) {
					// MAXX-156: a follow-up answered from conversation memory retrieves
					// nothing, so keep the topic of the answer it follows on from
					if (chunks.length === 0
						&& genericSpecialists.indexOf(message.specialist) !== -1
						&& !isUncertainResponse(raw_answer)) {
						topicLabels = _previousTopicLabels(reply_id);
						response.topic_carried = (topicLabels.length > 0);
					}

					response.text         = raw_answer;
					response.chunks       = chunks;
					response.topic_labels = topicLabels;

					// Final markdown pass — links, bold, headers
					finalizeStreamingBubble();
					translateAnswerMarkdownLinks(raw_answer, reply_id);

					// MAXX-117: append topic label(s)
					appendTopicLabel(reply_id, topicLabels, raw_answer, message.specialist);

					// Check for uncertain / hmm response
					checkAndAddAdditionalText(reply_id);

					// Store specialist in response for logging
					response.specialist = message.specialist;

					// MAXX-120: keep "Found N sources" above the reply when sources were retrieved
					if (chunks.length > 0) {
						moveActivityBadgeBelowReply(reply_id);
						$('#chatbot-activity-badge-' + reply_id).html(
							'<i class="fas fa-check-circle"></i> Found ' + chunks.length
							+ ' source' + (chunks.length === 1 ? '' : 's')
						);
					} else {
						$('#chatbot-activity-badge-' + reply_id).remove();
					}

					if (chunks.length > 0) {
						finalizeReferenceLinks(reply_id, chunks, raw_answer).then(function _onReferenceLinks(translatedChunks) {
							response.chunks = translatedChunks;
							logChatbotResponse('bedrock/' + message.specialist, json_payload, response, exec_time);

							if (mode === 'ask-maxx' && raw_answer
								&& raw_answer.toLowerCase().indexOf('hmm') === -1) {
								generateFollowUps(raw_answer);
							}

							raw_answer = null;
							response   = null;
						});
					} else {
						logChatbotResponse('bedrock/' + message.specialist, json_payload, response, exec_time);

						if (mode === 'ask-maxx' && raw_answer
							&& raw_answer.toLowerCase().indexOf('hmm') === -1) {
							generateFollowUps(raw_answer);
						}

						raw_answer = null;
						response   = null;
					}
				} else if (response.error) {
					$('#chatbot-activity-badge-' + reply_id).remove();
					updateMaxxBubble(askMaxxErrorResponse, reply_id);
					logChatbotResponse('bedrock/' + message.specialist, json_payload, response, exec_time);
					raw_answer = null;
					response   = null;
				} else {
					$('#chatbot-activity-badge-' + reply_id).remove();
					updateMaxxBubble(askMaxxErrorRetry, reply_id);
					logChatbotResponse('bedrock/' + message.specialist, json_payload, response, exec_time);
					raw_answer = null;
					response   = null;
				}

				return;
			}

			// ── error event from gateway ────────────────────────────────────
			if (message.error !== undefined) {
				response.error = message.error;
			}
		});

		// ── connection error ─────────────────────────────────────────────────
		source.addEventListener('error', function _onError() {
			source.close();
			stopStreamReveal();
			$('#chatbot-activity-badge-' + reply_id).remove();

			if (reply_id) {
				updateMaxxBubble(askMaxxErrorRetry, reply_id);
			} else {
				maxxBubble(askMaxxErrorRetry, '', false);
			}

			enableChatbotEntry();
		});

		source.stream();
	}

	// Map Bedrock tool names to human-readable labels for the activity badge
	function _toolNameToLabel(toolName) {
		var map = {
			search_vendor_partners: 'Partner Hub',
			search_destinations   : 'Destinations',
			search_cpgenie        : 'CP Genie',
			search_sailings       : 'Sailings',
			knowledge_agent       : 'Knowledge Base',
			text2sql_agent        : 'CP Maxx Business Data',
		};
		return map[toolName] || null;
	}

	// MAXX-156: display label for a kb_name, so raw names logged before a
	// topic had a kbMeta entry (e.g. cpmaxx_howto) still show their label
	function _kbNameToLabel(kbName)
	{
		return (kbName in kbMeta) ? kbMeta[kbName].label : kbName;
	}

	// MAXX-156: topic labels of the most recent earlier answer in this chat,
	// skipping answers labelled Uncertain or General
	function _previousTopicLabels(replyId)
	{
		var $replies = $('.chatbot-response .chatbot-bot-reply').not('#' + replyId),
			topic,
			i;

		for (i = $replies.length - 1; i >= 0; i--) {
			topic = $($replies[i]).data('topic');

			if (topic && topic !== 'Uncertain' && topic !== 'General') {
				return String(topic).split(', ');
			}
		}

		return [];
	}

	// Map terminal specialist value to a topic label when no chunks were retrieved
	function _specialistToTopicLabel(specialist)
	{
		var normalized,
			label;

		if (!specialist || genericSpecialists.indexOf(specialist) !== -1) {
			return null;
		}

		normalized = String(specialist).replace(/^search_/, '');

		if (normalized in kbMeta) {
			return kbMeta[normalized].label;
		}

		label = _toolNameToLabel(specialist) || _toolNameToLabel(normalized);

		return label;
	}

	// MAXX-122: reposition the activity badge BELOW the bot reply bubble.
	// When a references container is present, the badge sits directly above it
	// so it visually closes out the generated message and sits just before the
	// citation list.
	function moveActivityBadgeBelowReply(replyId)
	{
		var $badge     = $('#chatbot-activity-badge-' + replyId),
			$container = $('#ref-container-' + replyId),
			$insertAfter;

		if ($badge.length === 0) {
			return;
		}

		if ($container.length > 0) {
			$container.before($badge);
			return;
		}

		$insertAfter = getReplyBlockInsertPoint(replyId);

		if ($insertAfter.length > 0) {
			$insertAfter.after($badge);
		}
	}

	// DOM node after which citation cards and reply metadata should be inserted
	function getReplyBlockInsertPoint(replyId)
	{
		var $replyBubble = $('#' + replyId),
			$actions;

		if ($replyBubble.length === 0) {
			return $();
		}

		$actions = $replyBubble.nextAll('.chatbot-actions').first();

		if ($actions.length > 0) {
			return $actions;
		}

		return $replyBubble.next('.clearfix');
	}

	// Normalize indexed source URLs for consistent batch translation lookups.
	function normalizeSourceUrl(url)
	{
		var normalized = url;

		if (!normalized) {
			return '';
		}

		normalized = String(normalized).trim();
		normalized = normalized.replace(/^inapp:\/\/chatbot\//i, '');

		if (normalized.length > 1) {
			normalized = normalized.replace(/\/+$/, '');
		}

		return normalized;
	}

	function isCruiseTranslatableUrl(url)
	{
		if (!url) {
			return false;
		}

		return (/(\/sailing\/|\/CruiseSearch\/(?:viewMinimal|view)\/)/i).test(String(url));
	}

	function getUrlPath(url)
	{
		var path = normalizeSourceUrl(url);

		if (!path) {
			return '';
		}

		if ((/^https?:\/\//i).test(path)) {
			path = path.replace(/^https?:\/\/[^/?#]+/i, '');
		} else if ((/^\/\//).test(path)) {
			path = path.replace(/^\/\/[^/?#]+/i, '');
		} else if ((/^[\w.-]+\//i).test(path)) {
			path = path.replace(/^[\w.-]+/i, '');
		}

		return normalizeSourceUrl(path);
	}

	function normalizeUrlForTranslationApi(url)
	{
		var normalized = String(url).trim();

		if (!normalized) {
			return '';
		}

		if (normalized.indexOf('://') !== -1) {
			return normalizeSourceUrl(normalized);
		}

		if (normalized.indexOf('//') === 0) {
			return normalizeSourceUrl('https:' + normalized);
		}

		if (normalized.charAt(0) === '/') {
			return normalizeSourceUrl(normalized);
		}

		if ((/^[\w.-]+\//i).test(normalized)) {
			return normalizeSourceUrl('http://' + normalized);
		}

		return normalizeSourceUrl(normalized);
	}

	function isErezRelativeUrl(url)
	{
		return (/^\/[^/]+\/CruiseSearch\/view\/[^/?#]+\/\d+/i).test(String(url));
	}

	function isPublicCruiseUrl(url)
	{
		if (!url || isErezRelativeUrl(url)) {
			return false;
		}

		return isCruiseTranslatableUrl(url);
	}

	function extractCruiseSlugFromUrl(url)
	{
		var path  = getUrlPath(url),
			match;

		if (!path) {
			return '';
		}

		match = path.match(/\/(?:CruiseSearch\/(?:viewMinimal|view)|sailing)\/([^/?#]+)/i);

		if (!match) {
			return '';
		}

		try {
			return decodeURIComponent(match[1]);
		} catch (e) {
			return match[1];
		}
	}

	function buildLocalErezCruiseViewUrl(slugOrId)
	{
		if (!slugOrId || !Adzuki.base_uri) {
			return '';
		}

		return Adzuki.base_uri + '/CruiseSearch/view/' + encodeURIComponent(slugOrId) + '/1';
	}

	function rewritePublicCruiseLinksLocally(replyId)
	{
		var $targets = $('#' + replyId + '.chatbot-bot-reply, #ref-container-' + replyId),
			slug,
			localUrl;

		if (!$targets.length) {
			return;
		}

		$targets.find('a[href]').each(function _rewriteCruiseLink() {
			var $link = $(this),
				href  = $link.attr('href'),
				$card;

			if (!isPublicCruiseUrl(href)) {
				return;
			}

			slug = extractCruiseSlugFromUrl(href);

			if (!slug) {
				return;
			}

			localUrl = buildLocalErezCruiseViewUrl(slug);

			if (!localUrl) {
				return;
			}

			$link.attr('href', localUrl);
			$link.removeAttr('target rel');

			$card = $link.closest('.chatbot-reference-bedrock');

			if ($card.length) {
				$card.attr('data-source-url', localUrl);
			}
		});
	}

	function normalizeCruiseTranslatableUrl(url)
	{
		var value = String(url).trim(),
			path  = getUrlPath(value);

		if (path && isCruiseTranslatableUrl(path)) {
			return path;
		}

		if (isCruiseTranslatableUrl(value)) {
			return normalizeSourceUrl(value);
		}

		return '';
	}

	function isPassthroughReference(sourceUrl, ref)
	{
		var variants = getUrlVariants(sourceUrl),
			refPath  = getUrlPath(ref && ref.url ? ref.url : ''),
			i;

		if (!ref || !ref.url) {
			return true;
		}

		for (i = 0; i < variants.length; i++) {
			if (
				variants[i] === ref.url ||
				getUrlPath(variants[i]) === refPath
			) {
				return true;
			}
		}

		return false;
	}

	// Extract the indexed source URL from a Bedrock chunk payload.
	function getChunkIndexedUrl(chunk)
	{
		var metadata,
			pageContent,
			match,
			key,
			value;

		if (!chunk) {
			return '';
		}

		if (chunk.source_url) {
			value = normalizeCruiseTranslatableUrl(chunk.source_url);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(chunk.source_url);
		}

		if (chunk.sourceUrl) {
			value = normalizeCruiseTranslatableUrl(chunk.sourceUrl);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(chunk.sourceUrl);
		}

		if (chunk.url) {
			value = normalizeCruiseTranslatableUrl(chunk.url);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(chunk.url);
		}

		if (chunk.source && typeof chunk.source === 'object') {
			if (chunk.source.url) {
				return normalizeSourceUrl(chunk.source.url);
			}

			if (chunk.source.uri) {
				return normalizeSourceUrl(chunk.source.uri);
			}
		}

		if (typeof chunk.source === 'string') {
			value = normalizeCruiseTranslatableUrl(chunk.source);

			if (value) {
				return value;
			}

			if ((/^https?:\/\//i).test(chunk.source)) {
				return normalizeSourceUrl(chunk.source);
			}
		}

		if (chunk.location && chunk.location.url) {
			return normalizeSourceUrl(chunk.location.url);
		}

		metadata = chunk.metadata || {};

		if (metadata.source_url) {
			value = normalizeCruiseTranslatableUrl(metadata.source_url);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(metadata.source_url);
		}

		if (metadata.indexed_url) {
			value = normalizeCruiseTranslatableUrl(metadata.indexed_url);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(metadata.indexed_url);
		}

		if (metadata.url) {
			value = normalizeCruiseTranslatableUrl(metadata.url);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(metadata.url);
		}

		if (metadata.source) {
			value = normalizeCruiseTranslatableUrl(metadata.source);

			if (value) {
				return value;
			}

			if ((/^https?:\/\//i).test(metadata.source)) {
				return normalizeSourceUrl(metadata.source);
			}
		}

		if (metadata.link) {
			value = normalizeCruiseTranslatableUrl(metadata.link);

			if (value) {
				return value;
			}

			return normalizeSourceUrl(metadata.link);
		}

		for (key in metadata) {
			if (!Object.prototype.hasOwnProperty.call(metadata, key)) {
				continue;
			}

			if (key.indexOf('source-uri') !== -1 || key.indexOf('source_uri') !== -1) {
				value = metadata[key];

				if (value && (/^https?:\/\//i).test(value)) {
					return normalizeSourceUrl(value);
				}
			}
		}

		pageContent = chunk.pageContent || chunk.page_content || '';

		if (pageContent) {
			match = (/\((https?:\/\/[^)\s]+)\)/).exec(pageContent);

			if (match) {
				return normalizeSourceUrl(match[1]);
			}

			match = (/(\/(?:[^\s)\]",]*\/)?(?:CruiseSearch\/(?:viewMinimal|view)\/[^\s)\]",]+|sailing\/[^\s)\]",]+))/i).exec(pageContent);

			if (match) {
				value = normalizeCruiseTranslatableUrl(match[1]);

				if (value) {
					return value;
				}
			}

			match = (/(https?:\/\/[^\s<>"')]+)/).exec(pageContent);

			if (match) {
				return normalizeSourceUrl(match[1]);
			}
		}

		return '';
	}

	// Build a chunk object with a public URL, or no link when translation fails.
	function buildTranslatedChunk(chunk, ref)
	{
		var indexedUrl      = getChunkIndexedUrl(chunk),
			translatedChunk = {
				pageContent: chunk.pageContent || chunk.page_content || '',
				source_url : '',
				score      : chunk.score,
				metadata   : chunk.metadata ? $.extend({}, chunk.metadata) : {},
				kb_name    : chunk.kb_name || '',
			};

		if (indexedUrl) {
			translatedChunk.metadata.indexed_url = indexedUrl;
		}

		if (ref && ref.url) {
			translatedChunk.source_url = ref.url;

			if (ref.title) {
				translatedChunk.metadata.title = ref.title;
			}

			if (ref.subtitle) {
				translatedChunk.metadata.subtitle = ref.subtitle;
			}

			if (ref.image) {
				translatedChunk.metadata.image = ref.image;
			}
		}

		return translatedChunk;
	}

	// Apply translated public links to already-rendered citation cards.
	function updateReferenceCardLink($card, ref)
	{
		var sourceUrl    = ref.url,
			title        = ref.title || $card.find('.ref-url-plain').text().trim() || 'View source',
			linkLabel    = title,
			subtitle     = ref.subtitle || '',
			titleHtml    = '',
			subtitleHtml = '',
			titleBlockHtml;

		if (!sourceUrl) {
			return;
		}

		if (!linkLabel || linkLabel === sourceUrl) {
			linkLabel = 'View source';
		}

		if (isErezRelativeUrl(sourceUrl)) {
			titleHtml = '<a href="' + escapeHtml(sourceUrl) + '" class="ref-url">'
				+ escapeHtml(linkLabel) + '</a>';
		} else {
			titleHtml = '<a href="' + escapeHtml(sourceUrl) + '" target="_blank" rel="noopener" class="ref-url">'
				+ escapeHtml(linkLabel) + ' <i class="fas fa-external-link-alt" aria-hidden="true"></i></a>';
		}

		if (subtitle) {
			subtitleHtml = '<span class="ref-subtitle">' + escapeHtml(subtitle) + '</span>';
		}

		titleBlockHtml
			= '<div class="ref-title-block">'
				+ '<div class="ref-title-text">' + titleHtml + subtitleHtml + '</div>'
			+ '</div>';

		if ($card.find('.ref-title-block').length > 0) {
			$card.find('.ref-title-block').replaceWith(titleBlockHtml);
		} else {
			$card.find('.ref-snippet').after(titleBlockHtml);
		}

		// Card-level click uses data-source-url (not the <a> href), so keep them in sync.
		$card.attr('data-source-url', sourceUrl);
		$card.data('source-url', sourceUrl);
	}

	function applyReferenceLinksToCards(replyId, refs)
	{
		var $container = $('#ref-container-' + replyId);

		if ($container.length === 0) {
			return;
		}

		$container.find('.chatbot-reference-bedrock').each(function _updateCard() {
			var $card        = $(this),
				indexedUrl   = $card.attr('data-indexed-url') ||
					$card.attr('data-source-url') ||
					$card.find('a.ref-url').attr('href'),
				fallbackUrl  = $card.attr('data-source-url') || $card.attr('data-indexed-url'),
				ref;

			if (!indexedUrl) {
				return;
			}

			ref = getReferenceForUrl(refs, indexedUrl);

			if (ref && ref.url && !isPassthroughReference(indexedUrl, ref)) {
				updateReferenceCardLink($card, ref);
			} else if (fallbackUrl && !$card.find('a.ref-url').length) {
				updateReferenceCardLink($card, {
					url     : fallbackUrl,
					title   : 'View source',
					subtitle: '',
				});
			}
		});

		rewritePublicCruiseLinksLocally(replyId);
	}

	// Batch-translate indexed source URLs and update citation cards.
	function finalizeReferenceLinks(replyId, chunks, rawAnswer)
	{
		var urls             = [],
			indexedUrl,
			i,
			translatedChunks,
			refs;

		for (i = 0; i < chunks.length; i++) {
			indexedUrl = getChunkIndexedUrl(chunks[i]);

			if (indexedUrl) {
				addTranslatableUrl(urls, indexedUrl);
			}

			if (chunks[i].source_url) {
				addTranslatableUrl(urls, chunks[i].source_url);
			}
		}

		if (!urls.length) {
			return $.Deferred().resolve(chunks).promise();
		}

		return Adzuki.Ajax.post('/Ai/transformReferences/', {urls: urls}).then(function _onReferences(data) {
			refs             = data.references || {};
			translatedChunks = [];

			for (i = 0; i < chunks.length; i++) {
				indexedUrl = getChunkIndexedUrl(chunks[i]);
				translatedChunks.push(buildTranslatedChunk(chunks[i], indexedUrl ? getReferenceForUrl(refs, indexedUrl) : null));
			}

			applyReferenceLinksToCards(replyId, refs);
			updateRenderedLinkHrefs(replyId, refs);

			if (rawAnswer) {
				applyTableLinksFromRawMarkdown(rawAnswer, replyId);
			}

			applyTableLinksFromChunks(replyId, chunks, refs);
			rewritePublicCruiseLinksLocally(replyId);

			return translatedChunks;
		}).catch(function _onReferencesError() {
			return chunks;
		});
	}

	// Insert a citation card in descending score order as translations complete.
	function insertReferenceCardByScore($content, $card, score)
	{
		var inserted = false;

		$content.find('.chatbot-reference-bedrock').each(function _compareScores() {
			var existingScore = parseFloat($(this).attr('data-score')) || 0;

			if (score > existingScore) {
				$(this).before($card);
				inserted = true;
				return false;
			}
		});

		if (!inserted) {
			$content.append($card);
		}
	}

	// MAXX-119: Render a single source chunk as a citation card progressively.
	// Called once per `chunk` SSE event during streaming.
	function addChunkReference(chunk, meta, replyId)
	{
		var containerId  = 'ref-container-' + replyId,
			$container   = $('#' + containerId),
			indexedUrl   = getChunkIndexedUrl(chunk),
			score        = parseFloat(chunk.score) || 0,
			scoreLabel,
			scoreClass,
			scorePercent = Math.round(score * 100),
			snippet      = (chunk.pageContent || chunk.page_content || '').replace(/<[^>]+>/g, '').substring(0, 220).trim(),
			sourceUrl    = chunk.source_url || '',
			originalSourceUrl = chunk.source_url || '',
			title        = (chunk.metadata && chunk.metadata.title) ? chunk.metadata.title : '',
			linkLabel    = '',
			subtitle     = (chunk.metadata && chunk.metadata.subtitle) ? chunk.metadata.subtitle : '',
			titleHtml    = '',
			subtitleHtml = '',
			titleBlockHtml = '',
			cardHtml,
			$card,
			count,
			containerHtml,
			$insertAfter;

		// MAXX-158: CP Maxx How To guides have no public page to link to, their
		// text opens with the guide's front matter and their scores sit low even
		// on correct answers, so a card makes a good answer look weak. The topic
		// label above the answer still names the source.
		if (chunk.kb_name === 'cpmaxx_howto') {
			return;
		}

		// Below 0.40 the chunk is not relevant enough to surface to the advisor.
		if (score < 0.40) {
			return;
		}

		if (!sourceUrl && indexedUrl) {
			sourceUrl         = indexedUrl;
			originalSourceUrl = indexedUrl;
		}

		if (score >= 0.56) {
			scoreLabel = 'Strong match';
			scoreClass = 'score-strong';
		} else if (score >= 0.48) {
			scoreLabel = 'Good match';
			scoreClass = 'score-good';
		} else {
			scoreLabel = 'Related';
			scoreClass = 'score-related';
		}

		// Create the container once on the first chunk for this reply
		if ($container.length === 0) {
			containerHtml
				= '<div class="chatbot-references-container" id="' + containerId + '">'
					+ '<div class="chatbot-references-wrapper" id="ref-' + replyId + '">'
						+ '<div class="chatbot-reference-header chatbot-reference-toggle">'
							+ '<span class="ref-count-label">References (0)</span>'
							+ '<i class="fa fa-chevron-right chatbot-reference-toggle"></i>'
						+ '</div>'
						+ '<div class="chatbot-references-content" style="display: none;">'
							+ '<div class="chatbot-references-legend" aria-label="Match score scale">'
								+ '<span class="legend-item"><span class="legend-swatch score-strong"></span>Strong match (0.56+)</span>'
								+ '<span class="legend-item"><span class="legend-swatch score-good"></span>Good match (0.48–0.55)</span>'
								+ '<span class="legend-item"><span class="legend-swatch score-related"></span>Related (0.40–0.47)</span>'
							+ '</div>'
						+ '</div>'
					+ '</div>'
				+ '</div>';
			$insertAfter = getReplyBlockInsertPoint(replyId);

			if ($insertAfter.length > 0) {
				$insertAfter.after(containerHtml);
			} else {
				$('.chatbot-response').append(containerHtml);
			}

			$container = $('#' + containerId);

			// Toggle expand/collapse
			$container.on('click', '.chatbot-reference-header', function _toggleRefs() {
				$(this).find('.chatbot-reference-toggle').toggleClass('fa-chevron-right fa-chevron-down');
				$container.find('.chatbot-references-content').slideToggle();
			});
		}

		if (sourceUrl) {
			linkLabel = title;

			if (!linkLabel || linkLabel === sourceUrl) {
				linkLabel = 'View source';
			}

			if (isErezRelativeUrl(sourceUrl)) {
				titleHtml = '<a href="' + escapeHtml(sourceUrl) + '" class="ref-url">'
					+ escapeHtml(linkLabel) + '</a>';
			} else {
				titleHtml = '<a href="' + escapeHtml(sourceUrl) + '" target="_blank" rel="noopener" class="ref-url">'
					+ escapeHtml(linkLabel) + ' <i class="fas fa-external-link-alt" aria-hidden="true"></i></a>';
			}
		} else if (title) {
			titleHtml = '<span class="ref-url ref-url-plain">' + escapeHtml(title) + '</span>';
		}

		if (subtitle) {
			subtitleHtml = '<span class="ref-subtitle">' + escapeHtml(subtitle) + '</span>';
		}

		if (titleHtml || subtitleHtml) {
			titleBlockHtml
				= '<div class="ref-title-block">'
					+ '<div class="ref-title-text">' + titleHtml + subtitleHtml + '</div>'
				+ '</div>';
		}

		cardHtml
			= '<div class="chatbot-reference chatbot-reference-bedrock'
					+ (sourceUrl ? ' chatbot-reference-clickable' : '') + '"'
				+ ' data-score="' + score + '"'
				+ (originalSourceUrl ? ' data-source-url="' + escapeHtml(originalSourceUrl) + '"' : '')
				+ (indexedUrl ? ' data-indexed-url="' + escapeHtml(indexedUrl) + '"' : '')
				+ (sourceUrl ? ' role="link" tabindex="0"' : '')
				+ '>'
				+ '<span class="kb-tag ' + meta.cssClass + '">' + escapeHtml(meta.label) + '</span>'
				+ '<p class="ref-snippet">' + escapeHtml(snippet) + (snippet.length >= 220 ? '…' : '') + '</p>'
				+ titleBlockHtml
				+ '<div class="ref-score-bar-wrap">'
					+ '<div class="ref-score-bar ' + scoreClass + '" style="width:' + scorePercent + '%"></div>'
				+ '</div>'
				+ '<span class="ref-score-label ' + scoreClass + '">' + scoreLabel + ' (' + score.toFixed(2) + ')</span>'
			+ '</div>';

		$card = $(cardHtml);
		insertReferenceCardByScore($container.find('.chatbot-references-content'), $card, score);

		count = $container.find('.chatbot-reference').length;
		$container.find('.ref-count-label').text('References (' + count + ')');

		// MAXX-122: card-level click — the whole card navigates to the source URL.
		// Inner <a> elements (image and url label) keep their natural href for
		// browser affordances (status bar, right-click), but we always intercept
		// so the native mobile app bridges work.
		$container.find('.chatbot-reference').last().on('click', function _cardClick(e) {
			var url = $(this).data('source-url');

			if (!url) {
				return;
			}

			e.preventDefault();

			if ((/android/i).test(navigator.userAgent.toLowerCase())) {
				window.appInterface.postMessage(url);
			} else if (isIOS() || isIpadOS()) {
				window.webkit.messageHandlers.onClick.postMessage(url);
			} else if (isErezRelativeUrl(url)) {
				window.location.href = url;
			} else {
				window.open(url, '_blank', 'noopener');
			}
		});

		// Keyboard activation for accessibility (Enter / Space on the focused card)
		$container.find('.chatbot-reference').last().on('keydown', function _cardKeydown(e) {
			if ((e.key === 'Enter' || e.key === ' ') && $(this).data('source-url')) {
				e.preventDefault();
				$(this).trigger('click');
			}
		});

		rewritePublicCruiseLinksLocally(replyId);
	}

	function isUncertainResponse(text)
	{
		var lowerText = (text || '').toLowerCase(),
			phrases   = [
				'hmm',
				'i\'m sorry',
				'i am sorry',
				'don\'t have information',
				'do not have information',
				'cannot find',
				'can\'t find',
				'unable to find',
				'outside my knowledge',
				'not sure',
				'no information',
				'i don\'t know',
				'i do not know',
			],
			i;

		for (i = 0; i < phrases.length; i++) {
			if (lowerText.indexOf(phrases[i]) !== -1) {
				return true;
			}
		}

		return false;
	}

	// Infer KB topic labels from resumed answer text when chunk metadata is unavailable
	function inferTopicLabelsFromAnswer(text)
	{
		var labels    = [],
			lowerText = (text || '').toLowerCase(),
			checks    = [
				{
					match: ['partner hub', 'vendor partner', 'partners'],
					label: kbMeta.vendor_partners.label,
				},
				{
					match: ['destination'],
					label: kbMeta.destinations.label,
				},
				{
					match: ['cp genie', 'cpgenie', 'genie'],
					label: kbMeta.cpgenie.label,
				},
				{
					match: ['sailing', 'sailings'],
					label: kbMeta.sailings.label,
				},
				{
					match: ['cp maxx how to', 'cpmaxx_howto'],
					label: kbMeta.cpmaxx_howto.label,
				},
			],
			i,
			j;

		for (i = 0; i < checks.length; i++) {
			for (j = 0; j < checks[i].match.length; j++) {
				if (lowerText.indexOf(checks[i].match[j]) !== -1) {
					if (labels.indexOf(checks[i].label) === -1) {
						labels.push(checks[i].label);
					}
					break;
				}
			}
		}

		return labels;
	}

	// Restore citation cards from persisted chunk metadata when resuming a session.
	function restoreReferenceCards(chunks, replyId, fallbackText)
	{
		var chunk,
			i,
			kbName,
			meta;

		if (!chunks || chunks.length === 0) {
			if (fallbackText) {
				rebuildReferenceCardsFromMarkdown(fallbackText, replyId);
			}

			return;
		}

		for (i = 0; i < chunks.length; i++) {
			chunk  = chunks[i];
			kbName = chunk.kb_name || '';
			meta   = kbName in kbMeta ? kbMeta[kbName] : {
				label   : kbName || 'Source',
				cssClass: 'kb-unknown',
			};
			addChunkReference(chunk, meta, replyId);
		}

		finalizeReferenceLinks(replyId, chunks, fallbackText);
	}

	// Rebuild citation cards from inline markdown links when resuming a conversation
	function rebuildReferenceCardsFromMarkdown(text, replyId)
	{
		var regex        = /\[([^\]]+)\]\(([^\)]+)\)/g,
			match,
			entries        = [],
			urls           = collectTranslatableUrls(text),
			normalizedUrl,
			hasEntry,
			j;

		match = regex.exec(text);
		while (match !== null) {
			entries.push({
				text: match[1],
				url : match[2],
			});

			match = regex.exec(text);
		}

		urls.forEach(function _addPlainEntry(url) {
			hasEntry = false;

			for (j = 0; j < entries.length; j++) {
				normalizedUrl = normalizeSourceUrl(entries[j].url);

				if (normalizedUrl === url) {
					hasEntry = true;
					break;
				}
			}

			if (!hasEntry) {
				entries.push({
					text: url,
					url : url,
				});
			}
		});

		if (urls.length === 0) {
			return;
		}

		Adzuki.Ajax.post('/Ai/transformReferences/', {urls: urls}).then(function _onReferences(data) {
			var references = data.references || {},
				entry,
				ref,
				meta,
				lowerUrl,
				fakeChunk,
				i;

			for (i = 0; i < entries.length; i++) {
				entry    = entries[i];
				ref      = getReferenceForUrl(references, entry.url);
				lowerUrl = entry.url.toLowerCase();
				meta     = {
					label   : 'Source',
					cssClass: 'kb-unknown',
				};

				if (lowerUrl.indexOf('partner') !== -1 || lowerUrl.indexOf('vendor') !== -1) {
					meta = kbMeta.vendor_partners;
				} else if (lowerUrl.indexOf('destination') !== -1) {
					meta = kbMeta.destinations;
				} else if (lowerUrl.indexOf('genie') !== -1 || lowerUrl.indexOf('cpgenie') !== -1) {
					meta = kbMeta.cpgenie;
				} else if (lowerUrl.indexOf('sailing') !== -1 || lowerUrl.indexOf('cruise') !== -1) {
					meta = kbMeta.sailings;
				}

				fakeChunk = {
					pageContent: entry.text,
					source_url : (ref && ref.url) ? ref.url : '',
					score      : 0.50,
					metadata   : {
						title: (ref && ref.title) ? ref.title : entry.text,
					},
					kb_name: '',
				};
				addChunkReference(fakeChunk, meta, replyId);
			}
		}).catch(function _onReferencesError() {
			var entry,
				meta,
				lowerUrl,
				fakeChunk,
				i;

			for (i = 0; i < entries.length; i++) {
				entry    = entries[i];
				lowerUrl = entry.url.toLowerCase();
				meta     = {
					label   : 'Source',
					cssClass: 'kb-unknown',
				};

				if (lowerUrl.indexOf('partner') !== -1 || lowerUrl.indexOf('vendor') !== -1) {
					meta = kbMeta.vendor_partners;
				} else if (lowerUrl.indexOf('destination') !== -1) {
					meta = kbMeta.destinations;
				} else if (lowerUrl.indexOf('genie') !== -1 || lowerUrl.indexOf('cpgenie') !== -1) {
					meta = kbMeta.cpgenie;
				} else if (lowerUrl.indexOf('sailing') !== -1 || lowerUrl.indexOf('cruise') !== -1) {
					meta = kbMeta.sailings;
				}

				fakeChunk = {
					pageContent: entry.text,
					source_url : '',
					score      : 0.50,
					metadata   : {
						title: entry.text,
					},
					kb_name: '',
				};
				addChunkReference(fakeChunk, meta, replyId);
			}
		});
	}

	function getUrlVariants(url)
	{
		var normalized = normalizeSourceUrl(url),
			variants   = [],
			i;

		if (!normalized) {
			return variants;
		}

		variants.push(normalized);

		if (normalized.charAt(normalized.length - 1) !== '/') {
			variants.push(normalized + '/');
		}

		if (url && variants.indexOf(url) === -1) {
			variants.push(url);
		}

		for (i = 0; i < variants.length; i++) {
			if (variants[i].charAt(variants[i].length - 1) === '/') {
				variants.push(variants[i].slice(0, -1));
			}
		}

		return variants.filter(function _uniqueVariant(value, index, list) {
			return value && list.indexOf(value) === index;
		});
	}

	function addTranslatableUrl(urls, url)
	{
		var normalized = normalizeUrlForTranslationApi(url);

		if (normalized && urls.indexOf(normalized) === -1) {
			urls.push(normalized);
		}
	}

	function collectTranslatableUrls(text)
	{
		var urls           = [],
			markdownRegex  = /\[([^\]]+)\]\(([^\)]+)\)/g,
			plainPatterns  = [
				/https?:\/\/[^\s<>"')\],]+\/sailing\/[^\s<>"')\],]+/gi,
				/https?:\/\/[^\s<>"')\],]+\/CruiseSearch\/(?:viewMinimal|view)\/[^\s<>"')\],]+/gi,
				/(?:^|[\s(])\/(?:[^\s<>"')\],]*\/)?(?:sailing\/[^\s<>"')\],]+|CruiseSearch\/(?:viewMinimal|view)\/[^\s<>"')\],]+)/gi,
				/(?:^|[\s("'<>])[\w.-]+\/CruiseSearch\/(?:viewMinimal|view)\/[^\s<>"')\],]+/gi,
				/(?:^|[\s("'<>])[\w.-]+\/sailing\/[^\s<>"')\],]+/gi,
			],
			match,
			i,
			candidate;

		match = markdownRegex.exec(text);
		while (match !== null) {
			addTranslatableUrl(urls, match[2]);
			match = markdownRegex.exec(text);
		}

		for (i = 0; i < plainPatterns.length; i++) {
			match = plainPatterns[i].exec(text);
			while (match !== null) {
				candidate = match[0].replace(/^[\s(]+/, '');
				addTranslatableUrl(urls, candidate);
				match = plainPatterns[i].exec(text);
			}
		}

		return urls;
	}

	function collectTranslatableUrlsFromHtml(html)
	{
		var urls      = [],
			hrefRegex = /href="([^"]+)"/gi,
			match;

		match = hrefRegex.exec(html);
		while (match !== null) {
			if (isCruiseTranslatableUrl(match[1])) {
				addTranslatableUrl(urls, match[1]);
			}

			match = hrefRegex.exec(html);
		}

		return urls;
	}

	function updateRenderedLinkHrefs(replyId, references)
	{
		var $targets = $('#' + replyId + '.chatbot-bot-reply, #ref-container-' + replyId);

		$targets.find('a[href]').each(function _updateRenderedLink() {
			var $link = $(this),
				href  = $link.attr('href'),
				ref;

			ref = getReferenceForUrl(references, href);

			if (ref && ref.url && !isPassthroughReference(href, ref)) {
				$link.attr('href', ref.url);
				$link.removeAttr('target rel');

				if (ref.title && ($link.text().trim() === '' || $link.text().trim() === href)) {
					$link.text(ref.title);
				}
			}
		});

		rewritePublicCruiseLinksLocally(replyId);
	}

	function getReferenceForUrl(references, url)
	{
		var variants = getUrlVariants(url),
			path     = getUrlPath(url),
			apiUrl   = normalizeUrlForTranslationApi(url),
			key,
			i;

		if (!references) {
			return null;
		}

		if (references[url]) {
			return references[url];
		}

		apiUrl = normalizeUrlForTranslationApi(url);

		if (references[apiUrl]) {
			return references[apiUrl];
		}

		for (i = 0; i < variants.length; i++) {
			if (references[variants[i]]) {
				return references[variants[i]];
			}
		}

		if (path) {
			for (key in references) {
				if (!Object.prototype.hasOwnProperty.call(references, key)) {
					continue;
				}

				if (getUrlPath(key) === path) {
					return references[key];
				}
			}
		}

		return null;
	}

	function translateAnswerMarkdownLinks(rawAnswer, replyId)
	{
		var urls    = collectTranslatableUrls(rawAnswer),
			$bubble = $('#' + replyId + '.chatbot-bot-reply').first();

		if ($bubble.length) {
			collectTranslatableUrlsFromHtml($bubble.html()).forEach(function _mergeHtmlUrl(url) {
				addTranslatableUrl(urls, url);
			});
		}

		$('#ref-container-' + replyId).find('a[href]').each(function _mergeRefUrl() {
			addTranslatableUrl(urls, $(this).attr('href'));
		});

		if (urls.length === 0) {
			return;
		}

		Adzuki.Ajax.post('/Ai/transformReferences/', {urls: urls}).then(function _onReferences(data) {
			var references = data.references || {};

			updateRenderedLinkHrefs(replyId, references);
			applyTableLinksFromRawMarkdown(rawAnswer, replyId);
			rewritePublicCruiseLinksLocally(replyId);
		});
	}

	// MAXX-117: show every KB topic used, or "Uncertain" for refusals
	function appendTopicLabel(replyId, topicLabels, rawAnswer, specialist)
	{
		var $bubble        = $('#' + replyId);
		var topicText      = '';
		var specialistLabel = _specialistToTopicLabel(specialist);
		var labels          = (topicLabels || []).map(_kbNameToLabel);

		if ($bubble.find('.chatbot-topic-label').length > 0) {
			return;
		}

		if (isUncertainResponse(rawAnswer)) {
			topicText = '<br><small class="chatbot-topic-label">Topic: Uncertain</small>';
			$bubble.data('topic', 'Uncertain');
		} else if (labels.length > 0) {
			topicText = '<br><small class="chatbot-topic-label">Topic: ' + labels.join(', ') + '</small>';
			$bubble.data('topic', labels.join(', '));
		} else if (specialistLabel) {
			topicText = '<br><small class="chatbot-topic-label">Topic: ' + specialistLabel + '</small>';
			$bubble.data('topic', specialistLabel);
		} else {
			topicText = '<br><small class="chatbot-topic-label">Topic: General</small>';
			$bubble.data('topic', 'General');
		}

		if (topicText) {
			$bubble.append(topicText);
		}
	}

	// Add this new function
	function checkAndAddAdditionalText(reply_id) {
		var $bubble        = $('#' + reply_id + '.chatbot-bot-reply').first();
		var contents       = $bubble.html();
		var additionalText = ""; // "<br><br>Please check the <b>topic</b> at the top 👆 of this screen to help me answer your question correctly.";

		if (isUncertainResponse(contents)) {
			$bubble.append(additionalText);

			toggleTopicLabelAnimation(true);

			// Scroll to show the new content
			scrollContents($('.chatbot-response'));
		}
	}

	function sendFeedback() {
		var explanation = $('#chatbot-entry').val();
		$('#chatbot-entry').val('');

		// let's flip the stuff back for entry box
		$('#chatbot-entry').css('background-color', '#EFEFEF');
		$('#chatbot-entry').attr('placeholder', 'Ask me a question...');

		maxxBubble('Your feedback is pawsitively appreciated! Feel free to keep those questions coming—I\'m here to help! 🐶✨', '', false);
		scrollContents($('.chatbot-response'));

		badQuestionDetails.explanation = explanation;

		// send the data to the server
		Adzuki.Ajax.post('/Ai/sendFeedback/', badQuestionDetails)
		.then(function _sendFeedback(response) {
			// nothing to do
		});

		// resets the variables 
		lastAnswerBad        = false;
		askMaxxquestionAsked = true;
		badQuestionDetails   = {};
	}

	// send message to maxx intelligence
	function sendMaxxIntelligence(msg)
	{
		var prompt         = msg,
			prompt_trimmed = prompt.trim(),
			responses      = '',
			maxxSessionId  = $('#maxx-intelligence-session-id').val(),
			ellipsisInterval,
			formattedResponse,
			$ellipsis;

		advisorBubble(msg);
		maxxBubble("I\m thinking", maxxSessionId, true);

		// Animate ellipsis
		ellipsisInterval = setInterval(function _chatBotEllipsisInterval() {
			$ellipsis = $('#intell-loading-message .ellipsis');
			switch ($ellipsis.text()) {
				case '':
					$ellipsis.text('.');
					break;
				case '.':
					$ellipsis.text('..');
					break;
				case '..':
					$ellipsis.text('...');
					break;
				default:
					$ellipsis.text('');
			}
		}, 500);

		if (prompt_trimmed.length === 0) {
			Adzuki.StatusMessage('Error', 'Please provide a full prompt in order to proceed.');
		} else {
			// replace line breaks with spaces in prompt_trimmed
			prompt_trimmed = prompt_trimmed.replace(/(\r\n|\n|\r)/gm, " ");

			// clear the maxx intelligence entry box
			maxxIntelligenceQuestion = $('#maxx-intelligence-entry').val();
			$('#maxx-intelligence-entry').val('');

			// toggle maxx intelligence asked
			maxxIntelligenceAsked = true;

			Adzuki.Ajax.post('/Ai/processPrompt/', {prompt: prompt_trimmed}).then(function success(content) {
				$.each(content.messages, function onEachMessage(i, message) {
					responses += message + "\r\n";
				});

				// MAXX-170: the model's answer is text — escape it before the
				// list and bold passes add the only markup it should carry
				formattedResponse = escapeHtml(responses)
				// Separate the intro text from the list
				.replace(/^([\s\S]*?)\n(\d+\.\s+)/, '<p>$1</p><ul><li>')
				// Replace numbered items with list items
				.replace(/\n\d+\.\s+/g, '</li><li>')
				// Make text within ** bold
				.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')
				// Close the last list item and the unordered list
				.replace(/(<li>[\s\S]*?)$/, '$1</li></ul>');

				maxxBubble(formattedResponse, generateRandomString(), false);
				clearInterval(ellipsisInterval);

				// Scroll .maxx-intelligence-response to the bottom
				scrollContents($('.maxx-intelligence-response'));

				// remove any animations
				$('.chatbot-animations').remove();
			});
		}
	}

	// send message to the chatbot
	function sendMessage(msg)
	{
		var specificity,
			ellipsisInterval,
			$ellipsis;

		toggleTopicLabelAnimation(false);

		// if the last answer was bad, what's sent next is going to be feedback
		if (lastAnswerBad === true) {
			sendFeedback();
		} else {
			// add the question into the chatbot response box
			advisorBubble(msg);

			// Add "I'm looking this up" message with animated ellipsis
			maxxBubble('I\'m looking this up', '', true);

			// Animate ellipsis
			ellipsisInterval = setInterval(function _chatBotEllipsisInterval() {
				$ellipsis = $('#loading-message .ellipsis');
				switch ($ellipsis.text()) {
					case '':
						$ellipsis.text('.');
						break;
					case '.':
						$ellipsis.text('..');
						break;
					case '..':
						$ellipsis.text('...');
						break;
					default:
						$ellipsis.text('');
				}
			}, 500);

			scrollContents($('.chatbot-response'));

			// Set specificity based on the active button
			specificity = $('.chatbot-specificity-option-button.active').data('specificity');

			// clear the chatbot entry box
			askMaxxQuestion = $('#chatbot-entry').val();
			disableChatbotEntry();

			// toggle question asked
			askMaxxquestionAsked = true;

			// toggle save conversation button
			$('.chatbot-save-conversation').css('color', '#39B54A');

			// stream directly to Bedrock — no router call needed
			sendChatbotStreamedResponse(msg, specificity, ellipsisInterval);
		}
	}

	function sendToSnippets($obj)
	{
		var responseText = exportFreeHtml($obj).trim();

		Adzuki.Ajax.post('/Ai/saveSnippet/', {snippet: responseText}).then(function success(content) {
			maxxIntelligenceAsked = false;

			if ($('.maxx-intelligence-option-button.active').data('option') === 'history') { // eslint-disable-line no-lonely-if
				Adzuki.StatusMessage('Success', 'Saved to snippets');
			} else {
				maxxBubble('Woof! 🐶 I just saved it to your snippets');
				scrollContents($('.maxx-intelligence-response'));
			}
		});
	}

	// set session id
	function setSessionId()
	{
		var sessionId = generateRandomString();
		var timestamp = new Date().getTime();
		$('#chatbot-session-id').val(sessionId + '_' + timestamp);
	}

	function setMaxxIntelligenceSessionId()
	{
		var maxxSessionId = generateRandomString();
		var timestamp     = new Date().getTime();
		$('#maxx-intelligence-session-id').val(maxxSessionId + '_' + timestamp);
	}

	function setSpecificity(specificity) // eslint-disable-line no-unused-vars
	{
		// Bedrock AgentCore handles response style natively.
		// The specificity UI is kept for potential future use but no pre-warm
		// request is sent — the old Flowise endpoint it targeted no longer applies.
	}

	// set user photo in after
	function setUserPhotoInAfter()
	{
		var photoUrl = $('.photo').css('background-image');

		// Create a style element if it doesn't exist
		if (!$('#dynamic-styles').length) {
			$('head').append('<style id="dynamic-styles"></style>');
		}

		// Update or add the CSS rule
		$('#dynamic-styles').html('.chatbot-user-label::after { background-image: ' + photoUrl + '; }');
	}

	// show chatbot
	function showChatBot()
	{
		// Add backdrop
		$('body').append('<div class="chatbot-backdrop"></div>');
		$('.chatbot-backdrop').fadeIn();

		$('.chatbot-contents').removeClass('hidden');
		$('.chatbot-contents').slideDown();

		if ($('#chatbot-session-id').val() === '') {
			// if there is no session id set, do it
			setSessionId();

			// send a random message when it starts
			maxxBubble(getRandomIntro());
		}

		// load the topics that Maxx can choose from
		loadChoices();

		// Hide the chatbot logo container
		$('.chatbot-logo-container').hide();

		// reset the height of the chatbot
		setTimeout(function _setHeight() {
			$('.chatbot-contents').css('height', '650px');
		}, 500);
	}

	// // show bubbles
	// function showFollowupBubbles(followups) 
	// {
	// 	const bubblesHtml = `
	// 		'Simplify this'
	// 	];

	// 	const bubblesHtml = `
	// 		<div class="chatbot-followups">
	// 			${followups.map(followup => `
	// 				<button class="chatbot-followup-bubble" data-followup="${followup}" data-endpoint="${endpoint}">
	// 					${followup}
	// 				</button>
	// 			`).join('')}
	// 		</div>
	// 	`;
		
	// 	$('.chatbot-specificity').html(bubblesHtml);

	// 	scrollContents($('.chatbot-response'));
	// }

	function showFollowupBubblesNew(followups) 
	{
		let bubblesHtml = '<div class="chatbot-followups">';

		followups.forEach(followup => {
			bubblesHtml += `<button class="chatbot-followup-bubble" data-followup="${escapeHtml(followup)}" data-endpoint="">${escapeHtml(followup)}</button>`;
		});

		bubblesHtml += '</div>';
		$('.chatbot-specificity').html(bubblesHtml);

		scrollContents($('.chatbot-response'));
	}

	// show maxx intelligence
	function showMaxxIntelligence()
	{
		$('.chatbot-maxx-intelligence-container').show();
	}

	function textToSpeech() {
		const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;

		if (SpeechRecognition) {
			const recognition = new SpeechRecognition();
			recognition.continuous = false;
			recognition.interimResults = true;
			recognition.lang = "en-US";
			recognition.maxAlternatives = 1;

			const $microphoneIcon = $('.chatbot-microphone.active');
			const $textArea = $microphoneIcon.siblings('textarea');

			recognition.onstart = function _recognitionStart() {
				$microphoneIcon.empty().append('<i class="fas fa-spinner fa-spin" id="recognition-spinner"></i>');
			};

			recognition.onspeechend = function _recognitionSpeechEnd() {
				recognition.stop();
			};

			recognition.onend = function _recognitionEnd() {
				$microphoneIcon.empty();
				$microphoneIcon.removeClass('active');
			};

			recognition.onresult = function _recognitionResult(event) {
				let interimTranscript = '';
				let finalTranscript = '';

				for (let i = event.resultIndex; i < event.results.length; ++i) {
					if (event.results[i].isFinal) {
						finalTranscript += event.results[i][0].transcript;
					} else {
						interimTranscript += event.results[i][0].transcript;
					}
				}

				// Display interim results
				if (interimTranscript !== '') {
					$textArea.val(interimTranscript);
				}

				// Update with final results
				if (finalTranscript !== '') {
					$textArea.val(finalTranscript);
				}
			};

			recognition.onerror = function _recognitionError(event) {
				console.error('Speech recognition error:', event.error);
				$microphoneIcon.empty().append('<i class="fas fa-microphone"></i>');
				$microphoneIcon.removeClass('active');
				Adzuki.StatusMessage('error', 'Ensure that your microphone is turned on and/or your device is not muted.', 'Speech Recognition Error');
			};

			recognition.start();
			window.recognition = recognition;  // Store the recognition object globally
		} else {
			Adzuki.StatusMessage('error', 'Speech recognition is not supported in this browser. Please use Chrome for this feature.', 'Browser Not Supported');
		}
	}

	/**
	 * MAXX-170: what the advisor typed, made safe to show. Escaped first, so
	 * typed HTML shows as the characters typed, then bare http(s) URLs become
	 * links — the one convenience sanitizeHTML gave a question. The quote is
	 * escaped too, so a URL can't break out of its href.
	 *
	 * @param {string} text
	 * @return {string}
	 */
	function formatAdvisorText(text)
	{
		return escapeHtml(text).replace(/(https?:\/\/[^\s<]+)/g, '<a href="$1" target="_blank">$1</a>');
	}

	/**
	 * Formats MAXX's OWN messages (alerts, intros, feedback prompts), which
	 * carry markup on purpose. It escapes nothing, so it must never be given
	 * text an advisor typed or a model returned — use formatAdvisorText or
	 * formatResponse for those (MAXX-170).
	 */
	function sanitizeHTML(html) {
		let formattedText = '';

		// Skip link formatting if text contains cpmaxx or adzuki
		if (html.toLowerCase().includes('cpmaxx') || html.toLowerCase().includes('adzuki')) {
			return html;
		}

		if (containsMarkdown(html)) {
			// a script-style link renders as its label, as in buildMarkdownAnchor
			formattedText = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, function _formatLink(match, linkText, url) {
				if ((/^(?:javascript|vbscript|data):/i).test(String(url).replace(/\s+/g, ''))) {
					return linkText;
				}

				return '<a href="' + url + '" target="_blank">' + linkText + '</a>';
			});
		} else {
			formattedText = html.replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank">$1</a>');
		}

		return formattedText;
	}

	// MAXX-174: an Export CSV button under each table in a finished answer.
	// Called once the answer is complete (and on a resumed conversation), never
	// from updateMaxxBubble, which also repaints mid-stream.
	function addTableExports(reply_id)
	{
		if (!Adzuki.TableExport) {
			return;
		}

		Adzuki.TableExport.enhance($('#' + reply_id + '.chatbot-bot-reply').first(), {
			prefix : (mode === 'ask-maxx' ? 'ask-maxx' : 'maxx-intelligence'),
			wrapper: '.chatbot-table-wrapper',
		});
	}

	// A bubble's HTML without those buttons, for copying, snippets and saving.
	function exportFreeHtml($obj)
	{
		if (!Adzuki.TableExport || !$obj || !$obj.length) {
			return ($obj && $obj.length) ? ($obj.html() || '') : '';
		}

		return Adzuki.TableExport.cleanHtml($obj);
	}

	function updateMaxxBubble(bubble_contents, reply_id)
	{
		var $bubble       = $('#' + reply_id + '.chatbot-bot-reply').first();
		var $response_win = $('.chatbot-response').first();
		var rawContents   = bubble_contents;

		if (!$bubble.length) {
			return;
		}

		// formatResponse escapes before formatting, so plain-text answers and
		// error strings go through it too
		$bubble.html(formatResponse(bubble_contents));
		applyTableLinksFromRawMarkdown(rawContents, reply_id);
		rewritePublicCruiseLinksLocally(reply_id);
		$response_win.scrollTop($response_win.prop('scrollHeight'));
	}

	function containsMarkdown(text) {
		// Regular expressions for common Markdown patterns
		const patterns = [
			/\[.+?\]\(.+?\)/,          // Links: [text](url)
			/\*\*.+?\*\*/,             // Bold: **text**
			/\*.+?\*/,                 // Italic: *text*
			/^#{1,6}\s.+/m,            // Headers: # Header
			/`{1,3}[\s\S]+?`{1,3}/,    // Code: `code` or ```code block```
			/^\s*[-*+]\s/m,            // Unordered lists: - item or * item or + item
			/^\s*\d+\.\s/m,            // Ordered lists: 1. item
			/^\s*>.+/m,                // Blockquotes: > quote
			/!\[.+?\]\(.+?\)/,         // Images: ![alt text](url)
			/~~.+?~~/,                 // Strikethrough: ~~text~~
			/^\s*[-*_]{3,}\s*$/m,      // Horizontal rules: --- or *** or ___
			/^\s*\|[\s:|-]+\|\s*$/m    // Markdown tables: |---|---|
		];

		// Test each pattern against the text
		return patterns.some(pattern => pattern.test(text));
	}

	function stripHtmlAndFormat(html) {
		// Create a temporary element to parse the HTML
		var temp = document.createElement("div"),
			text = '';
		temp.innerHTML = html;
	
		// Get the text content
		text = temp.textContent || temp.innerText || "";
	
		// Replace common HTML elements with Markdown-like formatting
		text = text.replace(/\n{3,}/g, '\n\n'); // Replace multiple newlines with double newlines
		text = text.replace(/<\/?h[1-6]>/gi, '**'); // Replace header tags with bold
		text = text.replace(/<\/?strong>/gi, '**'); // Replace strong tags with bold
		text = text.replace(/<\/?b>/gi, '**'); // Replace b tags with bold
		text = text.replace(/<\/?em>/gi, '_'); // Replace em tags with italic
		text = text.replace(/<\/?i>/gi, '_'); // Replace i tags with italic
		text = text.replace(/<li>/gi, '• '); // Replace list items with bullet points
		text = text.replace(/<\/li>/gi, '\n'); // Add newline after list items
		text = text.replace(/<\/p>/gi, '\n\n'); // Add double newline after paragraphs
		
		// Replace links
		text = text.replace(/<a\s+(?:[^>]*?\s+)?href="([^"]*)"[^>]*>(.*?)<\/a>/gi, function _replaceLinks(match, url, linkText) {
			return linkText + ' (' + url + ')';
		});
	
		// Remove any remaining HTML tags
		text = text.replace(/<[^>]+>/g, '');
	
		// Trim extra whitespace
		text = text.trim();
	
		return text;
	}

	function containsNonLatinScript(text)
	{
		return (/[\u4e00-\u9fff\u3040-\u309f\u30a0-\u30ff\uac00-\ud7af\u0400-\u04ff\u0600-\u06ff]/).test(String(text));
	}

	/**
	 * Prefer the advisor's first question over AgentCore auto-generated titles,
	 * which can appear in unexpected languages.
	 *
	 * @param {Object} session
	 * @return {string}
	 */
	function getSessionDisplayTitle(session)
	{
		var title;

		if (session.display_title) {
			title = session.display_title;
		} else if (session.first_question) {
			title = session.first_question;
		} else if (session.title && !containsNonLatinScript(session.title)) {
			title = session.title;
		} else {
			title = 'New conversation';
		}

		title = String(title).replace(/\s+/g, ' ').trim();

		if (title.length > 80) {
			title = title.substring(0, 79) + '…';
		}

		return title;
	}

	/**
	 * Escape plain text for safe HTML insertion.
	 *
	 * @param {string} text
	 * @return {string}
	 */
	function escapeHtml(text)
	{
		return String(text)
			.replace(/&/g, '&amp;')
			.replace(/</g, '&lt;')
			.replace(/>/g, '&gt;')
			.replace(/"/g, '&quot;');
	}

	/**
	 * Render session list items into the conversation sidebar.
	 *
	 * @param {Array} sessions
	 */
	function renderConversationSessionList(sessions)
	{
		var html = '',
			title,
			dateStr;

		if (!sessions || sessions.length === 0) {
			return '<p class="conv-empty">No recent conversations found.</p>';
		}

		sessions.forEach(function _renderSession(session) {
			title = getSessionDisplayTitle(session);
			dateStr = session.started_at
				? new Date(session.started_at).toLocaleDateString([], {
					month : 'short',
					day   : 'numeric',
					hour  : '2-digit',
					minute: '2-digit',
				})
				: '';

			html
				+= '<div class="conv-session-item" data-session-id="' + escapeHtml(session.session_id) + '">'
					+ '<div class="conv-session-title">' + escapeHtml(title) + '</div>'
					+ '<div class="conv-session-date">' + dateStr + '</div>'
				+ '</div>';
		});

		return html;
	}

	/**
	 * Fetch and render the advisor's recent Bedrock sessions into the sidebar.
	 */
	function refreshConversationSessionList()
	{
		Adzuki.Ajax.post('/Ai/bedrockConversationList/', {}).then(function _onList(data) {
			if ($('#chatbot-conv-sidebar').length === 0) {
				return;
			}

			$('#chatbot-conv-sidebar .conv-sidebar-list').html(
				'<div class="conv-sidebar-section-header">Resume Conversation</div>'
				+ renderConversationSessionList(data.sessions)
			);
		}).catch(function _onListError() {
			if ($('#chatbot-conv-sidebar').length === 0) {
				return;
			}

			$('#chatbot-conv-sidebar .conv-sidebar-list').html(
				'<p class="conv-error">Could not load conversations. Please try again.</p>'
			);
		});
	}
	// ── MAXX-118: Conversation sidebar ─────────────────────────────────────────

	/**
	 * Show the conversation management panel — "Start New Conversation" at the
	 * top, then the advisor's last 10 sessions fetched from Bedrock.
	 */
	function loadConversationSidebar()
	{
		var $response = $('.chatbot-response'),
			titleRefreshTimer;

		// Ensure the chat panel is visible (sidebar lives inside .chatbot-response)
		$('.chatbot-details-container').show();
		$('.ask-maxx-card-intro').hide();

		// Replace any open sidebar instead of stacking duplicates
		$('#chatbot-conv-sidebar').remove();

		// Show a loading state while we fetch
		$response.append(
			'<div id="chatbot-conv-sidebar" class="chatbot-conv-sidebar">'
				+ '<div class="conv-sidebar-header">'
					+ '<strong>Conversations</strong>'
					+ '<button class="conv-sidebar-close btn btn-link"><i class="fas fa-times"></i></button>'
				+ '</div>'
				+ '<div class="conv-sidebar-body">'
					+ '<div class="conv-sidebar-new">'
						+ '<a href="#" class="conv-start-new"><i class="fas fa-plus-circle"></i> Start New Conversation</a>'
					+ '</div>'
					+ '<div class="conv-sidebar-list">'
						+ '<div class="conv-sidebar-section-header">Resume Conversation</div>'
						+ '<div class="conv-loading"><i class="fas fa-circle-notch fa-spin"></i> Loading...</div>'
					+ '</div>'
				+ '</div>'
			+ '</div>'
		);

		scrollContents($response);

		// Close button
		$('#chatbot-conv-sidebar').on('click', '.conv-sidebar-close', function _closeSidebar() {
			clearTimeout(titleRefreshTimer);
			$('#chatbot-conv-sidebar').remove();
		});

		// Start new conversation
		$('#chatbot-conv-sidebar').on('click', '.conv-start-new', function _startNew(e) {
			e.preventDefault();
			clearTimeout(titleRefreshTimer);
			$('#chatbot-conv-sidebar').remove();
			restartChatBot();
		});

		// Fetch recent sessions from Bedrock via PHP proxy
		Adzuki.Ajax.post('/Ai/bedrockConversationList/', {}).then(function _onList(data) {
			$('#chatbot-conv-sidebar .conv-sidebar-list').html(
				'<div class="conv-sidebar-section-header">Resume Conversation</div>'
				+ renderConversationSessionList(data.sessions)
			);

			// Titles may populate asynchronously — refresh once while sidebar is open
			titleRefreshTimer = setTimeout(function _refreshSessionTitles() {
				refreshConversationSessionList();
			}, 8000);
		}).catch(function _onListError() {
			$('#chatbot-conv-sidebar .conv-sidebar-list').html(
				'<p class="conv-error">Could not load conversations. Please try again.</p>'
			);
		});

		// Click a session to resume it
		$('#chatbot-conv-sidebar').on('click', '.conv-session-item', function _resumeSession() {
			var sessionId = $(this).data('session-id');
			clearTimeout(titleRefreshTimer);
			$('#chatbot-conv-sidebar').remove();
			resumeConversation(sessionId);
		});
	}

	/**
	 * Resume a past conversation by fetching its transcript and replaying the
	 * messages into the chat panel, then restoring the session ID so the advisor
	 * can continue where they left off.
	 *
	 * @param {string} sessionId  The padded Bedrock session ID
	 */
	function resumeConversation(sessionId)
	{
		// Reset the panel
		$('.chatbot-response').html('');
		$('.chatbot-specificity').html('');
		$('.chatbot-references').html('');

		// Set session ID so the next question continues the conversation
		$('#chatbot-session-id').val(sessionId);
		askMaxxquestionAsked = false;
		lastAnswerBad        = false;

		// Show a loading indicator
		maxxBubble('<i class="fas fa-circle-notch fa-spin"></i> Loading conversation...', generateRandomString(), false);

		Adzuki.Ajax.post('/Ai/bedrockSessionHistory/', {sessionId: sessionId}).then(function _onHistory(data) {
			// Clear loading message
			$('.chatbot-response').html('');

			if (!data.messages || data.messages.length === 0) {
				maxxBubble('No messages found for this conversation. Ask me anything!', generateRandomString(), false);
				return;
			}

			// Replay messages as bubbles
			data.messages.forEach(function _replayMessage(msg) {
				var replyId,
					topicLabels;

				if (msg.role === 'user') {
					advisorBubble(msg.text);
				} else {
					replyId = generateRandomString();
					askMaxxquestionAsked = true;
					maxxBubble('', replyId, false);
					updateMaxxBubble(msg.text, replyId);
					addTableExports(replyId);
					translateAnswerMarkdownLinks(msg.text, replyId);

					if (msg.topic_labels && msg.topic_labels.length > 0) {
						appendTopicLabel(replyId, msg.topic_labels, msg.text, msg.specialist);
					} else if (genericSpecialists.indexOf(msg.specialist) === -1) {
						topicLabels = inferTopicLabelsFromAnswer(msg.text);
						appendTopicLabel(replyId, topicLabels, msg.text, msg.specialist);
					} else {
						// MAXX-156: same carry-forward as a live answer with no sources
						appendTopicLabel(replyId, _previousTopicLabels(replyId), msg.text, msg.specialist);
					}

					restoreReferenceCards(msg.chunks, replyId, msg.text);
				}
			});

			askMaxxquestionAsked = true;
			loadChoices();
			scrollContents($('.chatbot-response'));
		}).catch(function _onHistoryError() {
			$('.chatbot-response').html('');
			maxxBubble('Could not load this conversation. Please start a new one.', generateRandomString(), false);
		});
	}

	function generateFollowUps(answer) {
		var msg       = '',
			loadingId = 'chatbot-followups-loading-' + generateRandomString();

		// Generic follow-up prompt — Bedrock handles all knowledge bases
		msg = 'Based on the following answer, generate a list of 3 highly relevant follow-up questions '
			+ 'in no more than 35 characters each if possible. '
			+ 'Return the response in JSON format with the key "followups" and an array of strings. '
			+ 'Here is the answer: ' + answer;

		$('.chatbot-specificity').html(
			'<span id="' + loadingId + '"><i class="fas fa-spinner fa-spin"></i> Suggesting follow-up questions...</span>'
		);

		// MAXX-155: act only while our loading message is still showing — asking
		// again or switching tabs replaces it, and those results must not land
		function _stillWaiting()
		{
			return $('#' + loadingId).length > 0;
		}

		// MAXX-155: every outcome other than rendered bubbles removes the message
		function _clearLoading()
		{
			if (_stillWaiting()) {
				$('.chatbot-specificity').html('');
			}
		}

		// processPrompt falls back to the signed-in advisor when no agent_id is sent
		Adzuki.Ajax.post('/Ai/processPrompt/', {
			prompt: msg,
		}).then(function _chatbotRequest(content) {
			var data      = (content && content.messages) ? content.messages : null,
				followups = [];

			try {
				if (Array.isArray(data) && typeof data[0] === 'string') {
					followups = JSON.parse(data[0].replace(/^```json\s*|\s*```$/g, '')).followups;
				}
			} catch (error) {
				console.error('Error parsing follow-ups:', error);
			}

			if (!Array.isArray(followups)) {
				followups = [];
			}

			followups = followups.filter(function _isQuestion(followup) {
				return typeof followup === 'string' && followup.trim() !== '';
			});

			if (followups.length > 0 && _stillWaiting()) {
				showFollowupBubblesNew(followups);
			} else {
				_clearLoading();
			}
		}).catch(function _onFollowUpsError() {
			_clearLoading();
		});
	}
}(jQuery, window.Adzuki || {}));
